// src/core.ts
function deepFreeze(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var defaultCore = deepFreeze({
  student_id: "",
  student_number: "",
  university: "",
  createdAt: 0,
  updatedAt: 0,
  legalAdviseDisclaimer: false,
  infoProcessingConsent: false,
  casIssued: false,
  email: "",
  assignedAgents: [],
  isPendingCognitoUser: false
});

// src/offer.ts
import { IntakeStatus } from "platform-lib/fe-safe";
function deepFreeze2(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze2(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var defaultOffer = deepFreeze2({
  intakeId: "",
  offerId: "",
  intakeStatus: IntakeStatus.ACTIVE
});

// src/finance-restrictedCountryBanks.ts
function deepFreeze3(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze3(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var restrictedCountryBanks = deepFreeze3({
  Cameroon: [
    {
      bank: "Afriland First Bank",
      isAccepted: true
    },
    {
      bank: "Banque Atlantique du Cameroun",
      isAccepted: true
    },
    {
      bank: "BGFI Bank Cameroun",
      isAccepted: true
    },
    {
      bank: "BICEC",
      isAccepted: true
    },
    {
      bank: "CITIBANK NA Cameroon",
      isAccepted: true
    },
    {
      bank: "Commercial Bank of Cameroon",
      isAccepted: true
    },
    {
      bank: "Credit Agricole - Societe Commerciale de Banque (CA-SCB)",
      isAccepted: true
    },
    {
      bank: "Ecobank Cameroun (EBC)",
      isAccepted: true
    },
    {
      bank: "National Financial Credit Bank",
      isAccepted: true
    },
    {
      bank: "SGBC",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank Cameroun (SCBC)",
      isAccepted: true
    },
    {
      bank: "Union Bank of Cameroon Ltd (UBC)",
      isAccepted: true
    },
    {
      bank: "United Bank For Africa Cameroun Plc (UBAC)",
      isAccepted: true
    }
  ],
  India: [
    {
      bank: "Scheduled Commercial Banks - India",
      isAccepted: true
    },
    {
      bank: "Abu Dhabi Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "American Express Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arab Bangladesh Bank Limited",
      isAccepted: true
    },
    {
      bank: "Allahabad Bank",
      isAccepted: true
    },
    {
      bank: "Andhra Bank",
      isAccepted: true
    },
    {
      bank: "Antwerp Diamond Bank NV",
      isAccepted: true
    },
    {
      bank: "Axis Bank Ltd",
      isAccepted: false
    },
    {
      bank: "Bank Internasional Indonesia",
      isAccepted: true
    },
    {
      bank: "Bank of America NA",
      isAccepted: true
    },
    {
      bank: "Bank of Bahrain & Kuwait BSC",
      isAccepted: true
    },
    {
      bank: "Barclays Bank Plc",
      isAccepted: true
    },
    {
      bank: "BNP PARIBAS",
      isAccepted: true
    },
    {
      bank: "Bank of Ceylon",
      isAccepted: true
    },
    {
      bank: "Bharat Overseas Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of Baroda",
      isAccepted: false
    },
    {
      bank: "Bank of India",
      isAccepted: true
    },
    {
      bank: "Bank of Maharashtra",
      isAccepted: true
    },
    {
      bank: "Canara Bank",
      isAccepted: false
    },
    {
      bank: "Central Bank of India",
      isAccepted: true
    },
    {
      bank: "Calyon Bank",
      isAccepted: true
    },
    {
      bank: "Citibank NA",
      isAccepted: true
    },
    {
      bank: "Cho Hung Bank",
      isAccepted: true
    },
    {
      bank: "Chinatrust Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Centurion Bank of Punjab Limited",
      isAccepted: true
    },
    {
      bank: "City Union Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coastal Local Area Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Corporation Bank",
      isAccepted: true
    },
    {
      bank: "Catholic Syrian Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "Development Credit Bank Ltd.",
      isAccepted: false
    },
    {
      bank: "Dena Bank",
      isAccepted: true
    },
    {
      bank: "Dhanlaxmi Bank",
      isAccepted: true
    },
    {
      bank: "IndusInd Bank Limited",
      isAccepted: true
    },
    {
      bank: "ICICI Bank",
      isAccepted: false
    },
    {
      bank: "IDBI Bank Limited",
      isAccepted: true
    },
    {
      bank: "IDFC Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Indian Bank",
      isAccepted: true
    },
    {
      bank: "Indian Overseas Bank",
      isAccepted: true
    },
    {
      bank: "Industrial Development Bank of India",
      isAccepted: true
    },
    {
      bank: "ING Vysya Bank",
      isAccepted: true
    },
    {
      bank: "J P Morgan Chase Bank, National Association",
      isAccepted: true
    },
    {
      bank: "Krung Thai Bank Public Company Limited",
      isAccepted: true
    },
    {
      bank: "Kotak Mahindra Bank Limited",
      isAccepted: false
    },
    {
      bank: "Karnataka Bank",
      isAccepted: true
    },
    {
      bank: "Karur Vysya Bank Limited.",
      isAccepted: true
    },
    {
      bank: "Lord Krishna Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Mashreqbank psc",
      isAccepted: true
    },
    {
      bank: "Mizuho Corporate Bank Ltd.",
      isAccepted: true
    },
    {
      bank: "Oman International Bank S A O G",
      isAccepted: true
    },
    {
      bank: "Oriental Bank of Commerce",
      isAccepted: true
    },
    {
      bank: "Punjab & Sind Bank",
      isAccepted: false
    },
    {
      bank: "Punjab National Bank",
      isAccepted: false
    },
    {
      bank: "Societe Generale",
      isAccepted: true
    },
    {
      bank: "Sonali Bank",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "State Bank of Mauritius Ltd",
      isAccepted: true
    },
    {
      bank: "SBI Commercial and International Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Bank of Bikaner and Jaipur",
      isAccepted: true
    },
    {
      bank: "State Bank of Hyderabad",
      isAccepted: true
    },
    {
      bank: "State Bank of India",
      isAccepted: true
    },
    {
      bank: "State Bank of Indore",
      isAccepted: true
    },
    {
      bank: "State Bank of Mysore",
      isAccepted: true
    },
    {
      bank: "State Bank of Patiala",
      isAccepted: true
    },
    {
      bank: "State Bank of Saurashtra",
      isAccepted: true
    },
    {
      bank: "State Bank of Travancore",
      isAccepted: true
    },
    {
      bank: "Syndicate Bank",
      isAccepted: true
    },
    {
      bank: "The Bank of Nova Scotia",
      isAccepted: true
    },
    {
      bank: "The Bank of Tokyo-Mitsubishi, Ltd",
      isAccepted: true
    },
    {
      bank: "The Development Bank of Singapore Ltd (DBS Bank Ltd.)",
      isAccepted: true
    },
    {
      bank: "The Hongkong & Shanghai Banking Corporation Ltd",
      isAccepted: true
    },
    {
      bank: "Tamilnad Mercantile Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bank of Rajasthan Limited",
      isAccepted: true
    },
    {
      bank: "The Federal Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The HDFC Bank Ltd",
      isAccepted: false
    },
    {
      bank: "The Jammu & Kashmir Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nainital Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sangli Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The South Indian Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Ratnakar Bank Ltd",
      isAccepted: false
    },
    {
      bank: "The Royal Bank of Scotland NV",
      isAccepted: true
    },
    {
      bank: "The Lakshmi Vilas Bank Ltd",
      isAccepted: true
    },
    {
      bank: "UCO Bank",
      isAccepted: true
    },
    {
      bank: "Union Bank of India",
      isAccepted: true
    },
    {
      bank: "United Bank Of India",
      isAccepted: true
    },
    {
      bank: "Vijaya Bank",
      isAccepted: true
    },
    {
      bank: "Yes Bank",
      isAccepted: false
    },
    {
      bank: "AP Mahajans Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "AP Janata Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "AP RajaRajeswari Mahila Co-Operative",
      isAccepted: true
    },
    {
      bank: "Abhinandan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Abhinav Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Abhivriddhi Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Abhyudaya Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Abiramam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Accountant General's Office Employees Co-opera",
      isAccepted: true
    },
    {
      bank: "ACE Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarniya PD Patil Saheb Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Mahila Mercantile Co-operative Bankltd",
      isAccepted: true
    },
    {
      bank: "Adarsh Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adarsha Pattana Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Adhyapaka Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Adoor Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agartala Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agra Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agrasen Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Agroha Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahilyadevi Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmedabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar Shahar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ahmednagar Zilla Prathamik Shikshak Saha Bank",
      isAccepted: true
    },
    {
      bank: "Ajantha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajinkyatara Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajinkyatara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajmer Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ajmer Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akhand Anand Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akkamahadevi Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Akki-Alur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akola District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Akola Merchant Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alappuzha District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alavi Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alibag Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aligarh Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Allahabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Allahabad UP Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Alleppey Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Almel Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Almora Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Almora Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alnavar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alwar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alwar Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Alwaye Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amalapuram Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amalner Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aman Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amanath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amarnath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambajogai Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambala Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambarnath Jai-Hind Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambasamudram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ambica Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ameer Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ammapet Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amod Nagric Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amravati District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amreli Jilla Madhyasth Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Amreli Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Amritsar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anand Mercantile Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ananda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anandeshwari Nagrik Sahakarti banAnanthasayanam Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anantnag Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anantpur co-op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andersul Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andhra Bank Employees Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andhra Pradesh Grameena Vikas Bank",
      isAccepted: true
    },
    {
      bank: "Andhra Pradesh Mahesh Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Andhra Pragathi Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Angul United Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ankaleshwar Udyognagar Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ankola Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Anna Sahaeb Magar Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Anuradha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Apani Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Apna Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Appasaheb Birnale Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arantangi Co-Op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arcot Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arihant Urban Co-Operative Bank",
      isAccepted: true
    },
    {
      bank: "Ariyalur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arjun Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arkonam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Army Base Work-Shop Credit Co-operative",
      isAccepted: true
    },
    {
      bank: "Arni Co-Operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aroodhjyoti Pattan Sahakara Bank Niyamith",
      isAccepted: true
    },
    {
      bank: "Arrah-Buxer District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arsikere Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aruna Sahakara Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Arunachal Pradesh Rural Bank",
      isAccepted: true
    },
    {
      bank: "Arvind Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Arya Vaishya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aryapuram Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aryavart Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Ashok Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ashok Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ashoknagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ashta People's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aska Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Assam Gramin Vikash Bank",
      isAccepted: true
    },
    {
      bank: "Astha Mahila Nagrik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Attur Town Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aurangabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Aurangabad District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "AVB Employees' Co-operative Credit Society & Bank",
      isAccepted: true
    },
    {
      bank: "Azad Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Azamgarh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "B Komarapalayam Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bagalkot Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bagalkot Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baghat Urban Coop Bank Limited Solan.",
      isAccepted: true
    },
    {
      bank: "Bahraich District central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bailhongal Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bailhongal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baitarani Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Bajirao Appa Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balangir District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balasore Coop.Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balasore District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balgeria Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balitikuri Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ballia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ballia -Etawah Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Bally Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Balotra Urban Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balsinor Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Balusseri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banaras Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banaskantha District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banaskantha Mercantile co-op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Banda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banda Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bangalore City Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bangalore District and Bangalore Rural",
      isAccepted: true
    },
    {
      bank: "Bangiya Gramin Vikash Bank",
      isAccepted: true
    },
    {
      bank: "Bank Jogindra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banki District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bankura District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Banswara Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bapatla Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bapuji Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bapunagar Maahilaa Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Barabanki District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baramati Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baramulla Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baran Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Baranagar Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bardoli Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bareilly Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baripada Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Barmer Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baroda City co-op bank Limited",
      isAccepted: true
    },
    {
      bank: "Baroda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baroda Gujarat Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Baroda Rajasthan Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Baroda Trader's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Baroda Uttar Pradesh Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Basaveshwar Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Basoda Nagrik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bassein Catholic Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Basti District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Batlagundu Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bavla Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bayad Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Beawar Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bechraji Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bedkihal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Beed District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Begusarai District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Begusarai District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Behrampore District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belgaum District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belgaum District Revenue Employees' Co-operative",
      isAccepted: true
    },
    {
      bank: "Belgaum Industrial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belgaum Zilla Rani Channamma Mahila Sahakari",
      isAccepted: true
    },
    {
      bank: "Bellad Bagewadi Urban Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bellary District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bellary Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Belur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Berhampur Co-Operative Urban Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Betul Nagarik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bhabhar Vibhag Nagarik sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhadgaon Peoples Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Bhadohi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhadradri Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhadran People's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhagalpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhagini Nivedita Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhagyodaya co-op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhagyodaya Friends Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhandara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhandari Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bharat Co-operative Bank (Mumbai) Ltd",
      isAccepted: true
    },
    {
      bank: "Bharat Heavy Electricals Employees Co op Bank",
      isAccepted: true
    },
    {
      bank: "Bharat Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bharath Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bharathiya Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Bharati Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bharatpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bharatpur Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhatinda Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhatkal Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhatpara Naihati Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhausaheb Birajdar Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavana Rishi Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavanagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavani Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhavani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavanikudal Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhavasar Kshatriya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhavnagar Mahila Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhawanipatna Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhilai Nagarik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bhilwara Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhilwara Mahila Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhilwara Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhimashankar Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhimavaram Co-op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhind Nagarik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bhinger Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhiwani Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhopal District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhopal Nagarik SahakariBank Limited",
      isAccepted: true
    },
    {
      bank: "Bhuj Commercial Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhuj Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bhupathiraju Co op Credit Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bhusawal People's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bicholim Urban Co- operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bidar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bidar Mahila Urban Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Big Kancheepuram Co op Town Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bihar Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Bijapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijapur District Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijapur Mahalaxmi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijapur Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bijapur Zilla Sarkari Naukarara Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Bijnor Jilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bijnor Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bikaner Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bilagi Pattan Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Birbhum District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Birdeo Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bodeli Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bombay Mercantile Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Borsad Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Botad Peoples Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Boudh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Brahmadeodada Mane Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Brahmawart Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bramhapuri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Broach District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Budaun Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Budge-Budge Nangi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Buldhana District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bundi Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bundi Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Burdwan Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Business Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Calicut Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cannanore Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cardamom Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Catholic Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cauvery Kalpatharu Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Chaitanya Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chaitanya Godavari Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Chaitanya Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chamba Urban Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chamoli Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chanasma Commercial Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chanasma Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandgad Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandrapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandraseniya Kayastha Prabhu Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chandwad Merchant's Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Changanacherry Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Charda Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Charminar Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chartered Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Chatrapur Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chembur Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chengalpattu Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chennai Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chennai Port Trust Employees Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chennimalai Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cherpalcheri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chhapi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chhattisgarh Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Chhopda Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Chidambaram Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chidambaranar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chikmagalur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chikmagalur Jilla Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Chikmagalur Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Chikmagalur-Kodagu Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Chiplun Urban Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chitradurg District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittoor Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittoor District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittorgarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chittorgarh Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Chopda People's Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Choudeshwari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Churu Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Churu Zilla Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Citizen Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Credit Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citizen Urban Co opBank Limited",
      isAccepted: true
    },
    {
      bank: "Citizens' Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "City Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Coastal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coimbatore City Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coimbatore District Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Col RD Nikam Sainik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Colour Merchants'Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Commercial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Comptroller's Office Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Contai Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coonoor Cooperative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Coop Bank of Baroda Ltd",
      isAccepted: true
    },
    {
      bank: "Coop Bank of Rajkot Ltd",
      isAccepted: true
    },
    {
      bank: "Co-operative bank of Mehsana Ltd",
      isAccepted: true
    },
    {
      bank: "Cooperative City Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cooperative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cordite Factory Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cosmos Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cuddalore & Villipuram DCCB Employees Co-Op",
      isAccepted: true
    },
    {
      bank: "Cuddalore District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cuddapah District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cumbum CoopTown Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Cuttack United Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "DY Patil Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dadasaheb Gajmal Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dadasaheb Ramrao Patil Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dahanu Road Janata Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dahod Mercantile Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dahod Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Daivadnya Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Dakor Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dakshin Dinajpur (Balurghat) District Central Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dakshina Kannada Jilla Mahila Co-operative Ban",
      isAccepted: true
    },
    {
      bank: "Dalmiapuram Empl.s'Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dapoli Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Darjeeling District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Darus Salam Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dattatraya Maharaj Kalambi Jaoli Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Daund Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dausa Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dausa Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Davangere Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Davangere Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Davangere-Harihar Urban Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Dayalbagh Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deccan Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deccan Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Deccan Merchants Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deendayal Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deepak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Defence Accounts Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dehradun District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Delhi Nagrik Sehkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dena Gujarat Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Deoghar Jamtara District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deogiri Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deola Merchants'Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Deoria Kasia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Desaiganj Nagari Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Development Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Devgad Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Devi Gayatri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Devyani Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhakuria Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhanashree Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhanbad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhanera Mercantile Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharampuri District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharamvir Sambhaji Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharapuram Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Dharmaj Peoples' Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharmapuri Co-op. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dharmavaram Co-op. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhinoj Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dholpur Urban Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhrangadhra Peoples'Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhule and Nandurbar Jilha Sarkari Nokaranchi",
      isAccepted: true
    },
    {
      bank: "Dhule Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dhulia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dilip Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dindigul Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dindigul Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "District Central Co-operative Bank Ltd, Bulandshahar",
      isAccepted: true
    },
    {
      bank: "District Co-operative Bank Ltd, Sitapur",
      isAccepted: true
    },
    {
      bank: "Dombivli Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dr Annasahab Chaugule Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dr Babasaheb Ambedkar Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Dr Babasaheb Ambedkar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dr Babasaheb Ambedkar Urban Co-operativeBank",
      isAccepted: true
    },
    {
      bank: "Dr Jaiprakash Mundada Urban Co-oprative Bank",
      isAccepted: true
    },
    {
      bank: "Dr Shivajirao Patil Nilangekar Urban Co-operativ",
      isAccepted: true
    },
    {
      bank: "Dumka District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Dungarpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Durga Co-op. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Durgapur Mahila Co-Operative Bank LtdDurgapur Steel Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Durg-Rajnandgaon Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Dwarakadas Mantri Nagari Sahakari Bk. Ltd",
      isAccepted: true
    },
    {
      bank: "Eastern & North East Frontier Railway Co-operative",
      isAccepted: true
    },
    {
      bank: "Eenadu Co-Operative Urban bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ellaquai Dehati Bank",
      isAccepted: true
    },
    {
      bank: "Eluri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Eluru Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Eluru District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ernakulam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Erode Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Erode District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etah District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etah Urban Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etawah Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Etawah Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Excellent Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faiz Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faizabad co-operative District Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faridabad Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Faridcot Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Farrukhabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Fatehabad Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Fatehgarh Sahib Central Co-operative Bank Ltd, Sirhind",
      isAccepted: true
    },
    {
      bank: "Fathehpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Fazilka Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Feroke Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ferozepur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Financial Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gadchiroli District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gadhinglaj Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandevi People's Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandhi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhi Gunj Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhibag Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhidham Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandhidham Mercantile Co-op.Bk.Ltd",
      isAccepted: true
    },
    {
      bank: "Gandhinagar Nagarik Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gandhinagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganesh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganga Mercantile Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganganagar Kendriya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ganraj Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gauhati Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gautam Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gayatri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "George Town Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ghaziabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghaziabad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghazipur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghazipur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ghoghamba Vibhag Nagarik Sahakari Bank Limite",
      isAccepted: true
    },
    {
      bank: "Ghoti Marchants Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Giridh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Goa Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gobichettipalyam Co op Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Godavari Laxmi Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Godavari Urban Co-op.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Godhra City Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Godhra Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gokak Urban Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gokul Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gomthi Nagariya Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gondal Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Gondia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gooty Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gopalganj District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gopinath Patil Parsik Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gorakhpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Government Employees Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Gozaria Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Graduates' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Grain Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Greater Bombay Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Guardian Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Gudiwada Co-op. Urban bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gudiyattam Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gujarat Ambuja Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gujarat Mercantile Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gulbarga District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gulshan Mercantile Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gumla Simdga District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guna District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guntur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guntur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Guntur Women Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gurdaspur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gurgaon Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Gurgaon Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Guruvayur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hadgali Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hadoti Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Halol Mercantile Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Halol Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hamirpur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hanamasagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hangal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hansot Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hanumanthanagar Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Hardoi District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hardoi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Harihareshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Harij Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Haryana Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Hassan District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hasti Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Haveli Sahakari Bank Maryadit.",
      isAccepted: true
    },
    {
      bank: "Haveri Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hazaribagh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Himachal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Himatnagar Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hindu Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hindustan Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hindustan Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hindustan Shipyard Staff Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hira Sugar Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hiriyur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hissar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hissar Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Honavar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hoogly District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hoshiarpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hospet Co-operative City Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hotel Industrialists Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Howrah District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hubli Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Hukeri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hutatma Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hyderabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ichalkaranji Merchants Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Idar Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Idukki District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ilayangudi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ilkal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Imperial Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Imperial Urban cooprative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Imphal Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Income Tax Department Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Independence Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indian Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indira Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indira Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indore Premier Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indraprastha Sehkari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Indrayani Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Industrial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Innespeta Coop urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Innovative Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Integral Urban co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Irinjalakuda Town Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Islampur Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "J&K Grameen Bank",
      isAccepted: true
    },
    {
      bank: "Jagruti Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jagruti Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jai Bhawani Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jai Hind Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jai Kalimata Mahila Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jain Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jain Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaipur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaipur Thar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Jaisalmer Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalana District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalaun District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon Merchants' Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalgaon People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalna Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalore Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalore Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jalpaiguri Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamkhandi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamkhed Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jammu Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamnagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamnagar mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jamnagar People's Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jampeta Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janakalyan Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janakalyan Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janalaxmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janaseva Sahakari (Borivli) Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janaseva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Coop Bank Ltd Godhra.",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janata Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janatha Seva Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jankalyan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janseva Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Janseva Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Jansewa Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jath Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaunpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jawahar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jawahar Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jay Tuljabhavani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jayprakash Narayan Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jaysingpur Udgaon Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jeypore coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhabua Dhar Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Jhajjar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhalawar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhalawar Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jhalod Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jharkhand Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Jhunjhunu Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jijamata Mahila Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jijamata Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jijau Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jilla Sahakari Kendriya Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Jind Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jivan Commercial Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jivhaji Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jodhpur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jodhpur Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jolarpet Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jowai Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Jubilee Hills Mercantile Co-Operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Jugalkishor Tapdia - Shri Mahesh Urban Co-opera",
      isAccepted: true
    },
    {
      bank: "Jullunder Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Junagadh Commercial Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Junagadh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kachchh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaduthuruthy Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kagal Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaira District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaithal Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kakatiya Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kakinada Co-op. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kakinada Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalghatgi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalinga Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Kallappanna Awade Ichalkaranji Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kallidaikurichi Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Kalol Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalol Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalpavruksha Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalupur Commercial Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalwan Marchants' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalyan Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalyan Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kalyansagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kamala Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kamaraj coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kamuthi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanaka Mahalakshmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanaka Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Kanara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kancheepuram Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kangra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kankaria Maninagar Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kannur (Cannanore) District Cooperative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kanyakumari District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kapadwanj Peoples' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kapurthala Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karad Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karaikudi Coop. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karamana Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karan Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karimnagar Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karimnagar District co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karjan Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karmala Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnal Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnala Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnataka Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnataka Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karnataka Rajya Kaigarika Vanijya Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Karnataka Vikas Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Karnavathi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karunagapalli Taluk Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karuntattankudi Dravidian Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karur Town Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Karwar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kasaragod District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kasargod Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kashi Gomti Samyut Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Kashipur Urban Co-opeerative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kasundia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Katihar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kattappana Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaujalgi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kaveripatnam Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kavita Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kedarnath Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kempegowda Pattana Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Kendrapara Urban Coop Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Keonjhar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kerala Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khagaria District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khalilabad Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khambhat Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khammam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khanapur Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khardah Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kheda Peoples' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khedbrahma Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kheralu Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Khurda Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kisan Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kittur Channamma Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kodagu District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodagu Zilla Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Kodaikanal Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodinar Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodinar Taluka Co-operative Banking Union Ltd",
      isAccepted: true
    },
    {
      bank: "Kodoli Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kodungallur Town Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kohinoor Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koilkuntla Co-Operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kokan Mercantile Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kokan Prant Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolar District Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolhapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolhapur Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolhapur Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolikata Mahila Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kolkata Police Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kollam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Konark Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Konnagar Samabaya Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Konoklota Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kopargaon Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koraput Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kosamba Mercantile Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kota Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kota Mahila Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kota Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koteshwara Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kottakal Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kottayam Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kottayam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kovilpatti Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kovvur Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Koyana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kozhikode District co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kranti Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishna District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishna Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Krishna Pattana Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Krishna Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishna Valley Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krishnagiri Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Krushiseva Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kshetriya Kisan Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Kukarwada Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kulitalai Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Kumbakonam Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kumbakonam Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kumbhi Kasari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kumta Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kunbi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kuppam Coop.Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurla Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurmanchal Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurnool District Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurukshetra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kurukshetra Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kushtagi Pattana Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Kutch Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kutch Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Kuttiady Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "LIC of India Staff Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "LIC Employees' Coop Bank LtdLakhimpur-Kheri District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lakhvad Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lala Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lalbaug Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lalgudi Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lalitpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Langpi Dehangi Rural Bank",
      isAccepted: true
    },
    {
      bank: "Lasalgaon Merchant's Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Latur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Laxmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Laxmi Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Laxmi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Laxmi Vishnu Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Liberal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Liluah Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Limbasi Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Limdi Urban Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Little Kancheepuram Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lokapavani Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Lokmangal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lokneta Dattaji Patil Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lokseva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lokvikas Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lonavla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lucknow University Adm Staff Primary Co-operative",
      isAccepted: true
    },
    {
      bank: "Lucknow Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ludhiana Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Lunawada Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Lunawada People's Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "MD Pawar Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "MS Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madanapalle Co-Op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madgaum Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madhavpura Mercantile Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madheshwari Urban Development Co-operative",
      isAccepted: true
    },
    {
      bank: "Madhya Bharat Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Madhya Bihar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Madikeri Town Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madura Sourashtra Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madurai District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Madurantakam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Magadh District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maha Mantralaya & Allied Offices Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahabaleshwar Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahabhairab Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahabubanagar District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahakaushal Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Mahalakshmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahalaxmi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahalingpur Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahamedha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahanagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahanagar Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maharaja Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maharana Pratap Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maharashtra Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Maharashtra Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Mahatma Fule District Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Mahatma Fule Urban Co-oprative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahaveer Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahaveer Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahendragarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahesh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahesh Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahila Co-Operative Nagrik Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahoba Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mahudha Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mainpuri District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Makarpura Industrial Estate Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malad Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malappuram District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malegaon Merchants Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mallapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malleswaram Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malpur Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malviya Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Malwa Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Manapparai Town Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandal Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandapeta Co-Operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandi Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandvi Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandvi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandya City Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mandya District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangal Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangaldai Nagar Samabai Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangalore Catholic Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mangalore Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maninagar Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manipal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manipur Rural Bank",
      isAccepted: true
    },
    {
      bank: "Manipur Women's Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manjeri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manjra Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manmad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manmandhir Co-Op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mannargudi Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manndeshi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Manorama Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansa Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansa Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansarovar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mansingh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mantha Urban Co-operative Bank LtdManvi Pattana Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Manwath Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mapusa Urban Co-operative Bank of Goa Ltd",
      isAccepted: true
    },
    {
      bank: "Maratha Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Maratha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Markandey Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Marketyard Commercial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Marwar Ganganagar Bikaner Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Masulipatanam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mathura Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Matoshri Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mattancherry Mahajanik Co-operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Mattancherry Sarvajanik Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mayani Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mayuram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mayurbhanj Central Co-operative Bank LtdMechanical Department Primary Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Medak District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Meenachil East Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Meerut District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Meghalaya Rural Bank",
      isAccepted: true
    },
    {
      bank: "Megharaj Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehmadabad Urban People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana District central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana Jilla Panchayat Karmachari Co op Bank",
      isAccepted: true
    },
    {
      bank: "Mehsana Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mehsana Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Melur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Memon Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mercantile Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mercantile Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchants' Liberal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchants' Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Merchants' Urban Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Mettupalayam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mewar Anchalik Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Millath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mirzapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mirzapur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mizoram Rural Bank",
      isAccepted: true
    },
    {
      bank: "Mizoram Urban Co-Op Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Modasa Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Model Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Model Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Modern Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moga Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mogaveera Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mohol Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moirang Primary Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Monghyr-Jamui District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moradabad Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Moti Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Motihari District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mudalgi Co operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Mudgal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mudhol Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mugberia District Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mukkuperi Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muktai Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muktsar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mula Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mulgund Urban Souharda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mumbai District Central Co-operative Bank Lt",
      isAccepted: true
    },
    {
      bank: "Mumbai Mahanager Palika Shikshan VibhagSaha",
      isAccepted: true
    },
    {
      bank: "Municipal Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Municipal Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Murshidabad District Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Musiri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muslim Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muvattupuzha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muzaffarnagar District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Muzaffarrur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore District central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore Merchant's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mysore Silk Cloth Merchants' Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Mysore Zilla Mahila Sahakara Bank Niyamitha.",
      isAccepted: true
    },
    {
      bank: "NE Rly Emp.Multi State Pri.Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Nabagram People's Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nadapuram Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nadia District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nadiad People's Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagaland Rural Bank",
      isAccepted: true
    },
    {
      bank: "Nagar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagar Vikas Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagarik Samabay Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagaur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagaur Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagina Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagnath Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagpur Mahanagarpalika Karmachari Sahahakari",
      isAccepted: true
    },
    {
      bank: "Nagpur Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nagrik Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nainital Almora Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Nainital District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nakodar Hindu Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nalanda District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nalbari Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nalgaonda District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Namakkal Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nandani Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nanded District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nandgaon Urban Co-operative Ltd",
      isAccepted: true
    },
    {
      bank: "Nandurbar Merchants' Co-op Ltd",
      isAccepted: true
    },
    {
      bank: "Narayanaguru Urban Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Narmada Malwa Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Naroda Nagrik Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik District Industrial & Mercantile Co-op Bank",
      isAccepted: true
    },
    {
      bank: "Nasik Jilha Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Merchant's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Road Deolali Vyapari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Zilla Girna Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Zilla Mahila Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nasik Zilla Sar & Par Karmachari Sah Bank",
      isAccepted: true
    },
    {
      bank: "National Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Insurance Emp Co-operative Cr & Bank",
      isAccepted: true
    },
    {
      bank: "National Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nav Jeevan Coop Bank",
      isAccepted: true
    },
    {
      bank: "Navabharat Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navakalyan Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Naval Dockyard Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navanagara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navanirman Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navapur Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navi Mumbai Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navnirman Coop.Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Navsarjan Industrial Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nawadh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nawanagar Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nawanshahr Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nayagarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nazareth Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nedumangad Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Needs of Life Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Neela Krishna co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Neelachal Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Nehru Nagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nellai Nagar Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nellore Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nellore District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nemmara Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nesargi Urban Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "New Agra Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "New India Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "New Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Neyyattinkara Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nicholson Coop. Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nidhi Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nilambur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nileshwar Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nilgiries Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nilkanth Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nipani Urban Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Niphad Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nirmal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nishigandha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nizamabad District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "NKGSB Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Noble Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Noida Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "North Arcot Ambedkar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "North Malabar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Northern Railway Primary Co-operative Bank.Ltd",
      isAccepted: true
    },
    {
      bank: "Nutan Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nutan Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Nyayamitra Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Ode Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ojhar Merchants Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Omalur Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Om-Datta Chaitanya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Omerga Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Omkar Nagriya Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ordinance Equip Factory Prarambhik Sahkari Bk",
      isAccepted: true
    },
    {
      bank: "Osmanabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Osmanabad Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ottapalam Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pachhapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pachora People's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Padmaavati Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Padmashri Dr.Vithalrao Vikhe Patil Co-operative",
      isAccepted: true
    },
    {
      bank: "Padra Nagar Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Padukkottai Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pala Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palakkad District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palamoor Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palani Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palanpur People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palayamkottai Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palghat Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pali Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pali Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pallavan Grama Bank",
      isAccepted: true
    },
    {
      bank: "Pallikonda Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Palus Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchkula Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchkula Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchmahals District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panchsheel Mercantile Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pandharpur Marchant's Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pandharpur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pandyan Grama Bank",
      isAccepted: true
    },
    {
      bank: "Panipat Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panipat Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Panvel Co-op. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Papanasam Coop. Urban Bank LtdParamakudi Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parbhani District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parner Taluka Sainik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parshwanath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Parvatiya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Parwanoo Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Paschim Banga Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Patan Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patan Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patdi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pathanamthitta District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patiala Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Patliputra Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pattukottai Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pavana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Payangadi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Payyanur Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Payyoli Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pen Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "People's Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Periyakulam Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pij People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pilibhit District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pimpalgaon Merchants'Co-op. BAnk Ltd d",
      isAccepted: true
    },
    {
      bank: "Pimpri Chinchwad Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Pioneer Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pioneer Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pithorgarh Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pochampally Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pollachi Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ponani Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pondicherry Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ponnampet Town Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Poona Marchant's Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Poornawadi Nagrik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Porbandar Commercial Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Porbandar Vibhagiya Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Postal & .MS Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragathi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragathi Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Pragathi Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Pragati Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragati Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pragati Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prakasam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prakasapuram Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pratap Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pratapgarh Jilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prathama Bank",
      isAccepted: true
    },
    {
      bank: "Prathamik Shikshak Sahakari bank ltd",
      isAccepted: true
    },
    {
      bank: "Prathamik Shikshak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pravara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Premier Automobile Employees' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prerna Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Prime Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pritisangam Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshani Mahila Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshani Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Mahila Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Mahila Urban Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Priyadarshini Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Proddatur Co-Op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Progressive Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Progressive Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Progressive Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pudukottai Coop.Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Puduvai Bharathiar Grama Bank",
      isAccepted: true
    },
    {
      bank: "Pune Cantonment Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pune District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pune Municipal Corporation Servants Co-operative",
      isAccepted: true
    },
    {
      bank: "Pune Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Pune Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Punjab & Maharashtra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Punjab Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Purasawalkam Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Puri Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Purnea District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Purulia Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Purvanchal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Pusad Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Puttur Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Quilon Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "RBI Employees' Co-op Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "RS Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raddi Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Radhasoami Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rae Bareli District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rahimatpur Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raichur City Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raichur District Central co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raigad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raigad Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raiganj Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Employees'Coop Banking Soc Ltd",
      isAccepted: true
    },
    {
      bank: "Railway Shramik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raj Laxmi Mahila Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajadhani Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajajinagar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajapalayam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajapur Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajapur Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajarambapu Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajarshi Shahu Government Servants' Co-op.Bank",
      isAccepted: true
    },
    {
      bank: "Rajarshi Shahu Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Rajasthan Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Rajasthan Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajdhani Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajgurunagar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajiv Gandhi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajkot Commercial Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajkot Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajkot Peoples Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajlaxmi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajmata Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajpipla Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajputana Mahila Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajsamand Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rajula Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramakrishna Mutually Aided Co-operative",
      isAccepted: true
    },
    {
      bank: "Ramanagaram Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramanathapuram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramanathapuram District Central Co-operative Bank Lt",
      isAccepted: true
    },
    {
      bank: "Rameshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramgarhia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rampur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ramrajya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranaghat People's Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranchi-Khunti Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rander People's Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Randheja Commercial Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranga Reddy Co-operative Urban Bank LtdRaniganj Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranilaxmibai Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranipet Town Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ranuj Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rasipuram Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ratanchand Shaha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ratnagiri District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ratnagiri Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Raver People's Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ravi Commercial Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rayat Sevak Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rendal Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Repalle Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Reserve Bank Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Reserve Bank Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Revdanda Co-op Urban bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rewari Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rewa-Sidhi Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Rohika Central Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rohtak Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ron Taluka Primary Teachers' Co-operative",
      isAccepted: true
    },
    {
      bank: "Ropar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rukhmini Nagari Sahakati Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rupee Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Rushikulya Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Sabarkantha District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sachin Industrial Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sadalga Urban Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sadguru Gahininath Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sadhana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sadhana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saharanpur District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahasrarjun Seva Kalyan Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahebrao Deshmukh Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahyadri Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sahyadri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sai Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Saibaba Janata Sahakari Bank LtdSaibaba Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Saidapet Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salal Sarvodaya Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salem District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salem Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Salur Cooperative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samarth Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samarth Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samastipur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samastipur Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Samata Co-operative Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samatha Mahila Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sambalpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sampada Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Samruddhi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sandur Pattana Souharda Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sangamner Merchant's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanghamitra Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli District Primary Teacher's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangli Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangola Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sangrur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sankari Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sankheda Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanmathi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanmitra Mahila Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sanmitra Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sanmitra Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sanmitra Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sant Motiram Maharaj Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sant Sopankaka Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Santrampur Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saptagiri Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Sarangpur Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Saraspur Nagarik Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Saraswat Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saraswathi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sardar Bhiladwala Pardi Peoples Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sardar Vallabhbhai Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sardarganj Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sardargunj Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarjerao-Dada Naik Shirala Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarsa People's Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sarva UP Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Commercial Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sarvodaya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sasaram Bhabua Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satana Merchants' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sathamba People's Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satpura Narmada Kshetriya",
      isAccepted: true
    },
    {
      bank: "Satyamangalam Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Satyashodhak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saurashtra Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Saurashtra Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Savanur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sawai Madhopur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sawai Madhopur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sawantwadi Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Secunderabad Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Secunderabad Mercantile Co-operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Seva Vikas Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sevalia Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Seven Hills Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shahada People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shahjahanpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shalini Sahakari Bank LtdShamrao Vithal Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shankar Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shankarrao Chavan Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shankerrao Mohite-Patil Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sharad Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sharad Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sharda Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Shatabdi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shedbal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shevapet Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shiggaon Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shihori Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shikshak Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shillong Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shimla Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shimoga Arecanut Mandy Merchants Co-operativ",
      isAccepted: true
    },
    {
      bank: "Shimoga District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shimsha Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Shirpur Merchants Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shirpur Peoples Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shiva Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shivaji Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivajirao Bhosale Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivalik Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivam Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivdaulat Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivneri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivparvati Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shivshakti Urban Co-op BnkLtd",
      isAccepted: true
    },
    {
      bank: "Sholapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sholavandan Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sholinghur Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shoranur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Agrasen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Baria Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Basaveshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Basaveshwar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Bhadran Mercantile Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Bharat Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Bhavnagar Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shree Botad Mercantile Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Dhandhuka Janta Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Dharati Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Gajanan Lokseva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Gajanan Maharaj Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Shree Gajanan Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Govardhansingji Raghuvashi Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shree Kadi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Lathi Vibhagiya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Laxmi Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Laxmi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Laxmi Mahila Sahakari Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Shree Lodhra Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahabaleshwar Co operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahalaxmi Mercantile Coop Bk Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahalaxmi Urban Co-operative Credit Bank",
      isAccepted: true
    },
    {
      bank: "Shree Mahavir Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shree Mahayogi Lakshmamma Co-Operative Ban",
      isAccepted: true
    },
    {
      bank: "Shree Mahesh Co-operative Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Mahuva Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Murugharajendra Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Shree Panchaganga Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Parswanth Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Savarkundla Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Savli Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Sidhhi Vinayak Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Talaja Nagarik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shree Tukaram Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Vardhaman Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Virpur Urban Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Vyas Dhanvarsha Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Warana Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shree Yugprabhav Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shreeji Bhatia Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shreenath Coop Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "Shreeram Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shreyas Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Shri Adinath Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Anand Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Anand Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Arihant Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Babasaheb Deshmukh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Balaji Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Balbhim Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Basaveshwar Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Bhagasara Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Bhailalbhai Contractor Smarak Co-operative",
      isAccepted: true
    },
    {
      bank: "Shri Bharat Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Bhausaheb Thorat Amrutvahini Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Chatrapati Shivaji Maharaj Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Chhani Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Chhatrapati Rajarshi Shahu Urban Co-operat",
      isAccepted: true
    },
    {
      bank: "Shri Chhatrapati Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Gajanan Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Ganesh Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Gurudev Brahmanand Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Shri Gurusiddheshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Kadasiddeshwar Pattan Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Kanyaka Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Lakshmi Krupa Urban Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Laxmi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahalaxmi Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahalaxmi Pattan Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Shri Mahant Shivayogi Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahaveer Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Mahila Sewa Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Morbi Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Nrusingh Saraswati sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Patneshwar Urban cooprative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Rajkot District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Rukmini Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Sai Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Satyavijay Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Shadakshari Shivayogi Siddharameshwar",
      isAccepted: true
    },
    {
      bank: "Shri Shantappanna Mirji Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Shri Sharada Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Sharan Veereshwar Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Shri Shiddheshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Shivaji Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Shivayogi Murughendra Swami Urban Co-op",
      isAccepted: true
    },
    {
      bank: "Shri Shiveshwar Nagri Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Siddeshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Swami Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Swami Samarth Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Veer Pulikeshi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Veershaiv Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Vijay Mahantesh Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Vinayak Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Shri Vyankatesh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shri Yashwant Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shrikrishna Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shrimant Malojiraje Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shripatrao Dada Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shriram Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shushruti Souharda Sahakara Bank Niyamita",
      isAccepted: true
    },
    {
      bank: "Siddaganga Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siddarthnagar District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siddharth Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Siddheshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siddheshwar Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Siddhi Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sihor Mercantile Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sihor Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sikar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sikar Urban Co Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sind Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sindgi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sindhudurg District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sindhudurg Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Singhbhum District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sinor Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sir M Vishweshwaraiah Sahakar Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sir M.Visvesvaraya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sircilla Co op Urban bank Limited",
      isAccepted: true
    },
    {
      bank: "Sirkali Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sirohi Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sirsa Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sirsi Urban Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sitamarhi Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sivagangai (Pasumpon) District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sivakasi Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Siwan Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Smriti Nagrik Sahakari Bank Maryadit., Mandsau",
      isAccepted: true
    },
    {
      bank: "Sojitra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Solapur Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Solapur Nagri Audhyogik Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Solapur Siddheshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Solapur Social Urban Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sonbhadra Nagar Sahkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sonepat Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sonpeth Nagri Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Soubhagya Mahila Souharda Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "South Canara District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "South Kanara Government Officers' Co-operative",
      isAccepted: true
    },
    {
      bank: "South Malabar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Sree Anjaneya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Bhyraveshwara Sahakara Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sree Chaitanya Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Charan Souharda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Harihareshwara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Narayana Guru Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Subramanyeswara Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sree Thyagaraja Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sreenidhi Souharda Sahakari Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sreenivasa Padmavatthi Co-Operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Sri Amba Bhavani Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Balaji Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Banashankari Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Basaveshwar Pattana Sahakari Bank Niyamit",
      isAccepted: true
    },
    {
      bank: "Sri Basaveshwar Sahakar Bank Niyamitha",
      isAccepted: true
    },
    {
      bank: "Sri Basaveshwara Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Basaveswar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Bhagavathi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Bharathi Co-op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Channabasavaswamy Souharda Pattana Saha",
      isAccepted: true
    },
    {
      bank: "Sri Durgadevi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Ganapathi Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Ganesh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Gavisiddeshwar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Gayatri Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Gokarnanath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Guru Raghavendra Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Kalahasti Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Kalidasa Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Kamalambika Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Kannikaparameshwari Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Kanyakaparameswari Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Krishnarajendra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Lakshmi Mahila Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Lakshminarayana Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Laxminarayana Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Mahatma Basaveshwar Co-Operative Bank",
      isAccepted: true
    },
    {
      bank: "Sri Mallikarjuna Pattana Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sri Parshwanatha Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Rama Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Revana Siddeshwar Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Seetharaghava Souharda Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Sharada Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Sharadamba Mahila Cooperative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Sri Sharanabasaveshwar Pattana Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Sri Siddarameshwara Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Sri Sudha Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Vasavamba Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Veerabhadreshwar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srikakulam Co-op.Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srikakulam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srimatha Mahila Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Sriramnagar Pattana Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Srirangam Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Srivilliputtur Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Stambhadri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Transport Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Transport Employees' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sterling Urban Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Subramanianagar Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "SUCO Souharda Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sudha Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Suleimani Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sultanpur Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sultan's Battery Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sumerpur Mercantile Urban Co-operative Bank Lt",
      isAccepted: true
    },
    {
      bank: "Sundargarh Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sundarlal Sawji Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat Mercantile Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat National Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surat Peoples Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surendranagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Surguja Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Sutlej Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Suvarna Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Suvarnayug Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Suvikas Peoples Co-Operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Swami Samarth Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Swami Vivekanand Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Swarna Bharathi Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Swarna Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Swasakthi Mercantile Co-Operative Urban Bank",
      isAccepted: true
    },
    {
      bank: "Swatantrya Senani",
      isAccepted: true
    },
    {
      bank: "Tadpatri Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Talikoti Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "Taliparamba Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Talod Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tambaram Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tamilnadu Circle Postal Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tamilnadu Industrial Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Tamluk-Ghatal Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tandur Mahila Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tanur Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tarapur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tasgaon Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tavaragera Pattana Souharda Sahakar Bank",
      isAccepted: true
    },
    {
      bank: "Teachers' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tehri Garhwal District Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tellicherry Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tenali Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Terna Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Textile Co-op.Bank of Surat Ltd",
      isAccepted: true
    },
    {
      bank: "Textile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Textile Manufacturers' Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Textile Traders' Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thane Bharat Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thane District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thane Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thanjavur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thanjavur Public Servants'Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thasra Peoples'Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Adilabad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Adinath Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Agrasen Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Akola Janata Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Akola Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati Merchants' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati Zilla Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Amravati Zilla-Parishad Shikshak Sahakari",
      isAccepted: true
    },
    {
      bank: "The Anantapur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Andaman and Nicobar State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Andhra Pradesh State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Anjangaon Surji Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Annasaheb Savant Co-Op. Urban Bank",
      isAccepted: true
    },
    {
      bank: "The Arunachal Pradesh State co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Assam Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Associate Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Aurangabad District Industrial & Urban Co-op",
      isAccepted: true
    },
    {
      bank: "The Badagara Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Baidyabati Sheoraphuli Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Bank Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bankura Town Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Bantra Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Bhagyalakshmi Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bhandara Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bihar Awami Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bihar State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Bishnupur Town Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Boral Union Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Chandigarh State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Chhattisgarh RajyaSahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "The Chikhli Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Chitnavispura Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Citizen Co operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Citizen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Citizens' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Delhi State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Devika Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Dr. Panjabrao Deshmukh Urban Co-operative",
      isAccepted: true
    },
    {
      bank: "The Eastern Railway Employees'Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Ghadchiroli Nagari Sahakari Bank",
      isAccepted: true
    },
    {
      bank: "The Ghatal Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Goa State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Gujarat Industrial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Gujarat Rajya Karmachari Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "The Gujarat State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Haryana State Co-opertive Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Himachal Pradesh State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Hooghly Co-operative Credit Bank Limited",
      isAccepted: true
    },
    {
      bank: "The Jalna People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jambusar People's Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jammu and Kashmir State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jamshedpur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Janata Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Jaynagar Mozilpur Peoples' Co-operative BanK",
      isAccepted: true
    },
    {
      bank: "The Kalna Town Credit Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Kangra Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Kapol Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Karnataka State Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Kashmir Mercantile Co-operative Bank Ltd,",
      isAccepted: true
    },
    {
      bank: "The Kerala State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Keshav Sehkari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Khamgaon Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Khatra Peoples' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Khattri Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Koylanchal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Krishnagar City Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Latur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Madhya Pradesh Rajya Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "The Maharashtra State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mahila Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mahila Vikas Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Malkapur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Manipur State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Meghalaya Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mehkar Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Midnapore People's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Mizoram Co-operative Apex Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Muzzaffarpur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nabadwip Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nabapalli Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nagaland State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nagarik Shakari Bank Maryadit, Jhabua",
      isAccepted: true
    },
    {
      bank: "The Nanded Merchant's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Nandura Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Navodaya Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Orissa State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Panihati Co-operative Bank LtdThe Pondichery State Co-opertive Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Prerna Nagari Sahakari Bank LtdThe Punjab State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Raipur Urban Mercantile Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Rajasthan State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sahyog Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Santragachi Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Shibpur Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sikkim State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Social Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sonepat Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Suri Friends' Union Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Sutex Co operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Tamil Nadu State Apex Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Tapindu Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Tripura State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Udgir Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Union Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Uttar Pradesh Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Uttaranchal Rajya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Uttarpara Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The V.S.V.Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaidyanath Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaijapur Merchants Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "The Vaish Co-operative Adarsh Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaish Co-operative Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vaish Co-operative New Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Vardhman Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Washim Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "The West Bengal State Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Yavatmal Mahila Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Yavatmal Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvaikuntam Co op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvalluvar Town Co-Op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvananthapuram District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thiruvannamali Sambuvarayar District Central",
      isAccepted: true
    },
    {
      bank: "Thodupuzha Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thrissur District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Thyagarayanagar Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tindivanam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchendoor Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchengode Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchirapalli City Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchirapalli District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruchirapalli Hirudayapuram Co-Op Credit Bank",
      isAccepted: true
    },
    {
      bank: "Tirukoilur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirumala Co-op. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirumangalam Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirunelveli Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirunelveli Junction Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirupati Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirupati Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirupattur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruppur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tirur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruturaipundi Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvalla East Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvalla Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvallur Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvannamalai Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tiruvathipuram Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tonk Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Town Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Town Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Transport Coop Bank Ltd, Indore",
      isAccepted: true
    },
    {
      bank: "Trichur Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tripura Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Trivandrum Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tumkur District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tumkur Grain Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tumkur Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Tumkur Veerashaiva Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tura Urban Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tuticorin Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Tuticorin Melur Co-Op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Twin Cities Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "UP Civil Secretriat Primary Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "UP Postal Primary Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Mahila Samridhhi Urban Coop Bk Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Mahila Urban Co-op.Bk.Ltd",
      isAccepted: true
    },
    {
      bank: "Udaipur Urban Coop. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udamalpet Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udhagmandlam Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udhana Citizen Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udupi Co-operative Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Udyam Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Ujjain Audhyogik Vikas Nagrik Sahkari Bank",
      isAccepted: true
    },
    {
      bank: "Ujjain Nagarik Sahakari Bank Maryadit, Ujjain",
      isAccepted: true
    },
    {
      bank: "Ujjain Paraspar Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Uma Cooperative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Umiya Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Umreth Urban Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Una Peoples' Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Unava Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Union Co op Bank Limited Naroda.",
      isAccepted: true
    },
    {
      bank: "United Commercial Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "United India Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Mercantile Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "United Puri Nimpara Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Universal Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Unjha Nagarik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Uravakonda Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Urban Co op Bank Limited",
      isAccepted: true
    },
    {
      bank: "Urban Co op Bank Limited Cuttack",
      isAccepted: true
    },
    {
      bank: "Usilampatti Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Uthamapalayam Coop. Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Utkal Coop Banking Soc Ltd",
      isAccepted: true
    },
    {
      bank: "Utkal Gramya Bank",
      isAccepted: true
    },
    {
      bank: "Uttar Banga Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Uttar Bihar Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Uttarakhand co-op. Bank LTD",
      isAccepted: true
    },
    {
      bank: "Uttaranchal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Uttarkashi Zilla Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Uttarsanda Peoples Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "VISL Employees' Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vadali Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vadnagar Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vaijanath Appa Saraf Marathwada Nagari Sahaka",
      isAccepted: true
    },
    {
      bank: "Vaikom Urban Co-operative Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vaishali District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaishali Urban Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaishya Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaishya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vallabh Vidhyanagar Commercial Co op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valmiki Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valparai Co-Operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valsad District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Valsad Mahila Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vananchal Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Vani Co-operative Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vani Merchants Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vaniyambadi Town Coop bank Ltd",
      isAccepted: true
    },
    {
      bank: "Varachha Co-operative bank Ltd",
      isAccepted: true
    },
    {
      bank: "Varaganeri Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Varanashi District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vardhaman (Mahila) Co-Op Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasai Janata Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasai Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasantdada Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vasavi Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vasundhara Mahila Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Veershaiva Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Veershaiva Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vejalpur Nagarik Sahakari bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vellala Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vellore Coop Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Velur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vepar Udhyog Vikas Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Veraval Mercantile Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Veraval Peoples Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vidharbha Kshetriya Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Vidharbha Merchants Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Vidisha Bhopal Kshetriya",
      isAccepted: true
    },
    {
      bank: "Vidya Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vidyanand Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vidyasagar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vijapur Nagrik Sahakari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vijay Commercial Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vijay Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Vikas Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vikas Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vikas Souharda Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vikas Urban Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Vikramaditya Nagarik Sahakari Bank Maryadit,",
      isAccepted: true
    },
    {
      bank: "Villupuram Coop Urban Bank Limited",
      isAccepted: true
    },
    {
      bank: "Villupuram District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vima Kamgar Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Virajpet Pattana Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Viramgam Mercantile Coop Bank Limited",
      isAccepted: true
    },
    {
      bank: "Viravanallur Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Virudhunagar Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Virudhunagar District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Visakhapatnam Co-op. Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishakapatnam District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishwakalyan Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Vishwakarma Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishwakarma Sahakara Bank",
      isAccepted: true
    },
    {
      bank: "Vishwanathrao Patil Murgud Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishwas Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vishweshwar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Visveshvaraya Grameena Bank",
      isAccepted: true
    },
    {
      bank: "Vita Merchants Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vita Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vitthal Nagari Sahari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vivekanada Nagarik Sahakari Bank Maryad.,Shuj",
      isAccepted: true
    },
    {
      bank: "Vriddhachalam Coop Urban Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vyankateshwara Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vyapari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Vyaparik Audhyogik Sahakari Bank Maryadit",
      isAccepted: true
    },
    {
      bank: "Vyavasayik Evam Audhyogik Sah.Bk.Maryadit.",
      isAccepted: true
    },
    {
      bank: "Vyavsaik Sahakari Bank Maryadit, Raipur",
      isAccepted: true
    },
    {
      bank: "Vysya Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Waghodia Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wai Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wainganga Krishna Gramin Bank",
      isAccepted: true
    },
    {
      bank: "Walchandnagar Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wana Nagrik Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wani Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Warangal Urban Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wardha District Ashirwad Mahila Nagari Sahakari",
      isAccepted: true
    },
    {
      bank: "Wardha District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wardha Nagari Sahakari Adhikosh (Bank)",
      isAccepted: true
    },
    {
      bank: "Wardha Zilla Parishad Employees (Urban) Co-op",
      isAccepted: true
    },
    {
      bank: "Wardhaman Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Warud Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Women's Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Wynad District Co-operative Central Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yadagiri Lakshmi Narasimha Swamy Co-op.Urban",
      isAccepted: true
    },
    {
      bank: "Yadrav Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yamuna Nagar Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yaragatti Urban Co-operative Credit Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yashwant Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yashwant Nagari Sahakari Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yavatmal District Central Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yawal Peoples Co-op Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yemmiganur Co-op Town Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yeola Merchants Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Yeshwant Urban Co-operative Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Youth Development Coop Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Garhwal",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Haridwar",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Jhansi",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Lucknow",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Mau",
      isAccepted: true
    },
    {
      bank: "Zilla Sahakari Bank Ltd, Unnao",
      isAccepted: true
    },
    {
      bank: "Zoroastrian Co-operative Bank Ltd",
      isAccepted: true
    }
  ],
  Ghana: [
    {
      bank: "Absa Bank Ghana Limited",
      isAccepted: false
    },
    {
      bank: "Access Bank (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "Agricultural Development Bank Ltd",
      isAccepted: false
    },
    {
      bank: "ARB Apex Bank",
      isAccepted: true
    },
    {
      bank: "Bank of Africa (Gh) Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of Baroda (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "Barclays Bank of Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "BSIC Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "CAL Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Citibank NA Ghana",
      isAccepted: true
    },
    {
      bank: "Ecobank Ghana Ltd",
      isAccepted: false
    },
    {
      bank: "Energy Bank (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "Fidelity Bank Ghana Ltd",
      isAccepted: false
    },
    {
      bank: "First Atlantic Bank Ltd",
      isAccepted: true
    },
    {
      bank: "First Capital Plus Bank Limited",
      isAccepted: true
    },
    {
      bank: "GCB Bank Plc",
      isAccepted: false
    },
    {
      bank: "Ghana Commercial Bank Limited",
      isAccepted: false
    },
    {
      bank: "Ghana International Bank Plc",
      isAccepted: true
    },
    {
      bank: "Guaranty Trust bank (Ghana) Ltd",
      isAccepted: false
    },
    {
      bank: "HFC Bank Ltd",
      isAccepted: true
    },
    {
      bank: "International Commercial Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Merchant Bank (Ghana) Ltd",
      isAccepted: false
    },
    {
      bank: "National Investment Bank Ltd",
      isAccepted: true
    },
    {
      bank: "OmniBSIC Bank Ghana Limited",
      isAccepted: false
    },
    {
      bank: "Prudential Bank Ltd",
      isAccepted: true
    },
    {
      bank: "The Royal Bank Ltd",
      isAccepted: true
    },
    {
      bank: "SG-SSB Ltd",
      isAccepted: true
    },
    {
      bank: "Stanbic Bank Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank Ghana Limited",
      isAccepted: true
    },
    {
      bank: "uniBank Ghana Ltd",
      isAccepted: true
    },
    {
      bank: "United bank for Africa (Ghana) Ltd",
      isAccepted: true
    },
    {
      bank: "UT Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Zenith Bank (Ghana) Ltd",
      isAccepted: false
    }
  ],
  Pakistan: [
    {
      bank: "Al-Baraka Islamic Banking BSC (EC)",
      isAccepted: true
    },
    {
      bank: "Allied Bank Limited",
      isAccepted: true
    },
    {
      bank: "American Express Bank Limited",
      isAccepted: true
    },
    {
      bank: "Askari Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bank Al-Falah",
      isAccepted: true
    },
    {
      bank: "Bank Al-Habib",
      isAccepted: true
    },
    {
      bank: "Bank of Ceylon",
      isAccepted: true
    },
    {
      bank: "Bank of KhyberBank of Tokyo Mitsubishi Limited",
      isAccepted: true
    },
    {
      bank: "Barclays",
      isAccepted: true
    },
    {
      bank: "Burj Bank",
      isAccepted: true
    },
    {
      bank: "Citibank",
      isAccepted: true
    },
    {
      bank: "Credit Agricole Indosuez (The Global French Bank)",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "Doha Bank",
      isAccepted: true
    },
    {
      bank: "Dubai Islamic Bank",
      isAccepted: true
    },
    {
      bank: "Faysal Bank",
      isAccepted: true
    },
    {
      bank: "First Women Bank",
      isAccepted: true
    },
    {
      bank: "GPO Abbottabad",
      isAccepted: true
    },
    {
      bank: "GPO Charsadda",
      isAccepted: true
    },
    {
      bank: "GPO Gujar Khan",
      isAccepted: true
    },
    {
      bank: "GPO Haripur",
      isAccepted: true
    },
    {
      bank: "GPO Jhelum",
      isAccepted: true
    },
    {
      bank: "GPO Kotli",
      isAccepted: true
    },
    {
      bank: "GPO Mardan",
      isAccepted: true
    },
    {
      bank: "GPO Mirpur",
      isAccepted: true
    },
    {
      bank: "GPO Multan",
      isAccepted: true
    },
    {
      bank: "GPO Nowshera",
      isAccepted: true
    },
    {
      bank: "GPO Peshawar",
      isAccepted: true
    },
    {
      bank: "GPO Swabi",
      isAccepted: true
    },
    {
      bank: "GPO Swat",
      isAccepted: true
    },
    {
      bank: "Habib bank AG Zurich",
      isAccepted: true
    },
    {
      bank: "Habib Bank Limited",
      isAccepted: true
    },
    {
      bank: "Habib Metropolitan Bank",
      isAccepted: true
    },
    {
      bank: "Industrial Development Bank of Pakistan (IDBP)",
      isAccepted: true
    },
    {
      bank: "International Finance Investment & Commerce Bank Limited",
      isAccepted: true
    },
    {
      bank: "JS bank",
      isAccepted: true
    },
    {
      bank: "KASB Bank",
      isAccepted: true
    },
    {
      bank: "Khushhali Bank",
      isAccepted: true
    },
    {
      bank: "Mashreq Bank PSC",
      isAccepted: true
    },
    {
      bank: "Meezan Bank",
      isAccepted: true
    },
    {
      bank: "Muslim Commercial Bank (MCB)",
      isAccepted: true
    },
    {
      bank: "National Bank of Pakistan",
      isAccepted: true
    },
    {
      bank: "National Investment Bank (NIB)",
      isAccepted: true
    },
    {
      bank: "National Investment Trust Limited (NIT)",
      isAccepted: true
    },
    {
      bank: "National Savings Abbottabad",
      isAccepted: true
    },
    {
      bank: "National Savings Bahawalpur",
      isAccepted: true
    },
    {
      bank: "National Savings Faisalabad",
      isAccepted: true
    },
    {
      bank: "National Savings Gujranwala",
      isAccepted: true
    },
    {
      bank: "National Savings Hyderabad",
      isAccepted: true
    },
    {
      bank: "National Savings Islamabad",
      isAccepted: true
    },
    {
      bank: "National Savings Karachi",
      isAccepted: true
    },
    {
      bank: "National Savings Lahore",
      isAccepted: true
    },
    {
      bank: "National Savings Multan",
      isAccepted: true
    },
    {
      bank: "National Savings Peshawar",
      isAccepted: true
    },
    {
      bank: "National Savings Quetta",
      isAccepted: true
    },
    {
      bank: "National Savings Sukkur",
      isAccepted: true
    },
    {
      bank: "Oman International Bank SOAG",
      isAccepted: true
    },
    {
      bank: "Pak Kuwait Investment Company (Pvt) Limited",
      isAccepted: true
    },
    {
      bank: "Pak Libya Holding Company (Pvt) Limited",
      isAccepted: true
    },
    {
      bank: "Pak Oman Investment Company (PVT) Limited",
      isAccepted: true
    },
    {
      bank: "Pakistan Industrial Credit & Investment Corporation Limited",
      isAccepted: true
    },
    {
      bank: "Punjab Provincial Corporative Bank (PPCB)",
      isAccepted: true
    },
    {
      bank: "Rupali Bank Limited",
      isAccepted: true
    },
    {
      bank: "Samba Bank Limited",
      isAccepted: true
    },
    {
      bank: "Saudi Pak Industrial & Agricultural Investment Company (Pvt) Limited",
      isAccepted: true
    },
    {
      bank: "Silk Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sindh Bank",
      isAccepted: true
    },
    {
      bank: "SME BANK",
      isAccepted: true
    },
    {
      bank: "Soneri Bank",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "Summit Bank",
      isAccepted: true
    },
    {
      bank: "The Bank of Azad Jammu & Kashmir (Bank of AJK)",
      isAccepted: true
    },
    {
      bank: "The Bank of Punjab",
      isAccepted: true
    },
    {
      bank: "The First Micro Finance Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Trust Bank",
      isAccepted: true
    },
    {
      bank: "United Bank Limited",
      isAccepted: true
    },
    {
      bank: "Zarai Taraqiati Bank Limited (ZTBL)",
      isAccepted: true
    },
    {
      bank: "Government Post Office Region Islamabad",
      isAccepted: true
    },
    {
      bank: "Government Post Office Region Karachi",
      isAccepted: true
    },
    {
      bank: "Government Post Office Region Lahore",
      isAccepted: true
    }
  ],
  "Iran, Islamic Republic of": [
    {
      bank: "Pasargad Bank",
      isAccepted: true
    },
    {
      bank: "Parsian Bank",
      isAccepted: true
    },
    {
      bank: "en Bank",
      isAccepted: true
    },
    {
      bank: "Mellat Bank",
      isAccepted: true
    },
    {
      bank: "Melli Bank",
      isAccepted: true
    },
    {
      bank: "Tejarat Bank",
      isAccepted: true
    },
    {
      bank: "Ghavvamin Bank",
      isAccepted: true
    },
    {
      bank: "Bank Keshavarzi (Agri Bank)",
      isAccepted: true
    },
    {
      bank: "Bank Sedarat: Bank Saderat Iran",
      isAccepted: true
    },
    {
      bank: "Saman Bank",
      isAccepted: true
    },
    {
      bank: "Fereshtegan",
      isAccepted: true
    },
    {
      bank: "Samenolaemeh",
      isAccepted: true
    },
    {
      bank: "Samenolhojaj Bank",
      isAccepted: true
    },
    {
      bank: "Bank Maskan",
      isAccepted: true
    }
  ],
  Philippines: [
    {
      bank: "ABN Amro Bank",
      isAccepted: true
    },
    {
      bank: "Al-Amanah Islamic Bank",
      isAccepted: true
    },
    {
      bank: "Allied Banking Corporation",
      isAccepted: true
    },
    {
      bank: "Allied Savings Bank",
      isAccepted: true
    },
    {
      bank: "Asia United Bank",
      isAccepted: true
    },
    {
      bank: "Australia & New Zealand Banking Group (ANZ)",
      isAccepted: true
    },
    {
      bank: "Banco de Oro Unibank, Inc",
      isAccepted: true
    },
    {
      bank: "Bangkok Bank Public Co Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of America",
      isAccepted: true
    },
    {
      bank: "Bank of China (Limited - Manila Branch)",
      isAccepted: true
    },
    {
      bank: "Bank of Commerce",
      isAccepted: true
    },
    {
      bank: "Bank of the Philippine Islands",
      isAccepted: true
    },
    {
      bank: "Bank of Tokyo-Mitsubishi",
      isAccepted: true
    },
    {
      bank: "BDO Elite Savings Bank",
      isAccepted: true
    },
    {
      bank: "BDO Private Bank",
      isAccepted: true
    },
    {
      bank: "BPI Capital Corporation",
      isAccepted: true
    },
    {
      bank: "BPI Card Finance Corporation",
      isAccepted: true
    },
    {
      bank: "BPI Direct Savings Bank",
      isAccepted: true
    },
    {
      bank: "BPI Family Savings Bank",
      isAccepted: true
    },
    {
      bank: "BPI Globe BanKo, Inc.",
      isAccepted: true
    },
    {
      bank: "BPI Leasing Corporation",
      isAccepted: true
    },
    {
      bank: "China Banking Corporation",
      isAccepted: true
    },
    {
      bank: "China Bank Savings, Inc",
      isAccepted: true
    },
    {
      bank: "China Trust (Phils) Commercial Bank",
      isAccepted: true
    },
    {
      bank: "Citibank",
      isAccepted: true
    },
    {
      bank: "Citibank Savings, Inc.",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "Development Bank of the Philippines",
      isAccepted: true
    },
    {
      bank: "East West Bank",
      isAccepted: true
    },
    {
      bank: "Export and Industry Bank",
      isAccepted: true
    },
    {
      bank: "First Consolidated Bank",
      isAccepted: true
    },
    {
      bank: "HSBC - Hongkong and Shanghai Banking Corporation",
      isAccepted: true
    },
    {
      bank: "HSBC Savings Bank (Phils)",
      isAccepted: true
    },
    {
      bank: "ING Bank (Internationale Nederlanden Groep Bank N.V. - Manila Branch)",
      isAccepted: true
    },
    {
      bank: "ISLA Bank (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "JP Morgan Chase Bank",
      isAccepted: true
    },
    {
      bank: "Korea Exchange Bank",
      isAccepted: true
    },
    {
      bank: "Land Bank of the Philippines",
      isAccepted: true
    },
    {
      bank: "Malayan Bank Savings and Mortgage Bank",
      isAccepted: true
    },
    {
      bank: "Maybank Philippines",
      isAccepted: true
    },
    {
      bank: "Mega International Commercial Bank",
      isAccepted: true
    },
    {
      bank: "Metropolitan Bank and Trust Company",
      isAccepted: true
    },
    {
      bank: "Mizuho Corporate Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Philippine Bank of Communications",
      isAccepted: true
    },
    {
      bank: "Philippine Business Bank",
      isAccepted: true
    },
    {
      bank: "Philippine National Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Savings Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Veterans Bank",
      isAccepted: true
    },
    {
      bank: "Planters Development Bank",
      isAccepted: true
    },
    {
      bank: "Queen City Development Bank",
      isAccepted: true
    },
    {
      bank: "RCBC Capital Corporation",
      isAccepted: true
    },
    {
      bank: "RCBC Savings Bank",
      isAccepted: true
    },
    {
      bank: "Rizal Commercial Banking Corporation",
      isAccepted: true
    },
    {
      bank: "Robinsons Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Security Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "The Real Bank",
      isAccepted: true
    },
    {
      bank: "UCPB Leasing and Finance Corporation (ULFC)",
      isAccepted: true
    },
    {
      bank: "UCPB Savings Bank",
      isAccepted: true
    },
    {
      bank: "Unionbank of the Philippines",
      isAccepted: true
    },
    {
      bank: "United Coconut Planters Bank",
      isAccepted: true
    },
    {
      bank: "World Partner's Bank (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "1st Macro Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "1st Macro Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "1st Valley Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "5 Speed Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "A B Capital and Investment Corporation",
      isAccepted: true
    },
    {
      bank: "Advantage Bank Corp. (A Microfinance-Oriented Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Agri-Business Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Agricom Rural Bank (Sta. Maria,Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "Agusan Norte - Butuan City Coop RB",
      isAccepted: true
    },
    {
      bank: "Air Materiel Wing Savings & Loan Association, Inc. (AMWSLAI)",
      isAccepted: true
    },
    {
      bank: "Aliaga Farmers Rural Bank (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "AMA Bank (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Anilao Bank (Rural Bank of Anilao (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Armed Forces of the Phils. Savings & Loan Association, Inc. (AFPSLAI)",
      isAccepted: true
    },
    {
      bank: "Arsenal Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Asian Consumers Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Asiatrust Development Bank",
      isAccepted: true
    },
    {
      bank: "ASLA Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Aspac Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Aurorabank (A Microfinance-Oriented Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Baclaran Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bagong Bangko Rural ng Malabang, Inc.",
      isAccepted: true
    },
    {
      bank: "Baguio Vendors Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Balanga Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Baliuag Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Alabang, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Bakun, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Batangan, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Carmona, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Banco de Arevalo, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco de Mindoro, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Dingras (Comm. RB Dingras, Inc.)",
      isAccepted: true
    },
    {
      bank: "Banco Dipolog, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Banco Makiling, A Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Maximo, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco ng Masa, Inc. (A Microfinance-Oriented Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Banco Rural de General Tinio (BRGT), Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Rural de Isla Cordova, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco San Juan, Inc.",
      isAccepted: true
    },
    {
      bank: "Banco Sual (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Buena Consolidated, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Bangko Carrascal, Inc. (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Kabayan (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Mabuhay (RB of Tanza, Inc.)",
      isAccepted: true
    },
    {
      bank: "Bangko Magsaysay (Isabela), Inc. - A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Bangko Pangasinan - A Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Pasig (Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Rural ng Magarao (Camarines Sur), Inc.",
      isAccepted: true
    },
    {
      bank: "Bangko Rural ng Pasacao, Inc.",
      isAccepted: true
    },
    {
      bank: "BANGKO RURAL NG SAN TEODORO",
      isAccepted: true
    },
    {
      bank: "Bangko Rural ng Tagoloan, Inc.",
      isAccepted: true
    },
    {
      bank: "Bank of Florida, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Bank of Makati (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Bank One Savings and Trust Corporation",
      isAccepted: true
    },
    {
      bank: "Banko Nuestra Sra. del Pilar, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Bannawag Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Basa Air Base Savings & Loan Associatiom, Inc.",
      isAccepted: true
    },
    {
      bank: "Bataan Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Bataan Development Bank",
      isAccepted: true
    },
    {
      bank: "Bataan Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Batanes Government Employees Savings & Loan, Inc.",
      isAccepted: true
    },
    {
      bank: "Batangas Rural Bank for Coop., Inc.",
      isAccepted: true
    },
    {
      bank: "Baybank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Benguet Centre Bank, Inc. A Rural Bank",
      isAccepted: true
    },
    {
      bank: "BHF Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bicol Teachers Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Bi\xF1an Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Binangonan Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "BIR Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Bolbok Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bottlers Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Bridgeway Rural Banking Corp.",
      isAccepted: true
    },
    {
      bank: "Builders Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Bukidnon Bank, INC (RB of Kalilangan)",
      isAccepted: true
    },
    {
      bank: "Business and Consumers Bank (A Dev't. Bank)",
      isAccepted: true
    },
    {
      bank: "Butuan City Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Cabanatuan City Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Cagsawa Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Camiling Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Cantilan Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Capitol City Bank, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Capiz Settlers Cooperative Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Card Bank, Inc. (A Microfinance Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Card SME Bank, Inc. A Thrift Bank",
      isAccepted: true
    },
    {
      bank: "Cavite Naval Base Savings and Loan Association,Inc. (CNBSLAI)",
      isAccepted: true
    },
    {
      bank: "Cavite Rural Banking Corporation",
      isAccepted: true
    },
    {
      bank: "CDCP Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Cebu International Finance Corporation",
      isAccepted: true
    },
    {
      bank: "Cebuana Lhuillier Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Central Equity Rural Bank",
      isAccepted: true
    },
    {
      bank: "Central Visayas Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Century Rural Bank Inc.(RB of Babak Inc.)",
      isAccepted: true
    },
    {
      bank: "Century Savings Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Certified Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Citizen's Rural Bank (Cabiao), Inc.",
      isAccepted: true
    },
    {
      bank: "City Savings Bank",
      isAccepted: true
    },
    {
      bank: "Citystate Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Classic Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Bank (RB of Alfonso, Inc.)",
      isAccepted: true
    },
    {
      bank: "Community RB of Naawan, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Catmon, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Clarin, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Dapitan City, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Magallon, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Magsaysay, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Medellin, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of Romblon, Inc.",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of San Felipe, Inc",
      isAccepted: true
    },
    {
      bank: "Community Rural Bank of San Gabriel, Inc.",
      isAccepted: true
    },
    {
      bank: "Composite Wing Savings and Loan Association, Inc. (CWSLAI)",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Agusan del Sur",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Aurora",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Benguet",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cagayan",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Camarines Norte",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cavite",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cebu",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Cotabato",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Ilocos Norte",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Iloilo",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of La Union",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Leyte-Leyte Coop RB",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Misamis",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Mt. Province",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Negros Oriental",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Nueva Vizcaya",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Palawan",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Pampanga, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Quezon Province",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Surigao del Sur",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Tarlac, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Bank of Zambales",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Bohol, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Bukidnon, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Bulacan, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Davao del Sur, Inc.",
      isAccepted: true
    },
    {
      bank: "Cooperative Rural Bank of Zamboanga del Norte",
      isAccepted: true
    },
    {
      bank: "Cordillera Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Cordillera Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Country Rural Bank of Taguig, Inc.",
      isAccepted: true
    },
    {
      bank: "Countryside Coop Rural Bank of Batangas",
      isAccepted: true
    },
    {
      bank: "Countryside Rural Bank of Palauig (Zambales), Inc.",
      isAccepted: true
    },
    {
      bank: "Crown Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "CSFirst Bank, INC. - A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Cuyapo Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "D' Asian Hills Bank (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "De La O Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Delmont Bank, Inc. (RB of San Jose del Monte)",
      isAccepted: true
    },
    {
      bank: "DEPW Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "DER Savings & Loan Association, Inc. (DERSALA)",
      isAccepted: true
    },
    {
      bank: "Diamond Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Dumaguete City Development Bank",
      isAccepted: true
    },
    {
      bank: "Dumaguete Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Dungganon Bank, Inc. (A Microfinance Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "Earist Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "East Coast Rural Bank, Inc.(RB Hagonoy)",
      isAccepted: true
    },
    {
      bank: "Eastern Rizal Rural Bank Inc.(Jala-Jala Rural Bank)",
      isAccepted: true
    },
    {
      bank: "EIB Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Emerald Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Empire Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Enterprise Bank, Inc. A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Enterprise Capital Bank (Rural Bank of Taguig)",
      isAccepted: true
    },
    {
      bank: "Entrepreneur Rural Bank",
      isAccepted: true
    },
    {
      bank: "Equicom Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Faculty Savings & Loan Association of Adamson University, Inc.",
      isAccepted: true
    },
    {
      bank: "Far Eastern Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Farm Bank (A Rural Bank) - Farmer's Bank of Capiz, Inc.",
      isAccepted: true
    },
    {
      bank: "Farmers Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Farmers Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Fernando Air Base Savings & Loan Association, Inc. (FABSLAI)",
      isAccepted: true
    },
    {
      bank: "Fil-Agro Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Filidian Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Filipino Savers Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Finman Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Agro-Industrial Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Community Bank, Inc.(A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "First Integrity Bank, Inc. (Rural Bank of Bailen)",
      isAccepted: true
    },
    {
      bank: "First Isabela Cooperative Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Malayan Leasing & Finance Corporation",
      isAccepted: true
    },
    {
      bank: "First Metro Investment Corporation",
      isAccepted: true
    },
    {
      bank: "First Midland Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Mindoro Microfinance Rural Bank, INC.",
      isAccepted: true
    },
    {
      bank: "First Naga Bank ( A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "First Provincial Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "First State Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "First Tagum Rural Bank , Inc.",
      isAccepted: true
    },
    {
      bank: "First United Farmers Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Forestry Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Frontier Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Gateway Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "GM BANK OF LUZON, INC. (A RURAL BANK)",
      isAccepted: true
    },
    {
      bank: "Golden Rural Bank of the Philippines, Inc.",
      isAccepted: true
    },
    {
      bank: "Grand-Agri Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Green Bank (Rural Green Bank of Caraga)",
      isAccepted: true
    },
    {
      bank: "GSIS Bayanihan Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "GSIS Family Bank, A Thrift Bank",
      isAccepted: true
    },
    {
      bank: "Guagua Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Guagua Savers Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Gulf Bank, Inc. (RB of Lingayen, Inc.)",
      isAccepted: true
    },
    {
      bank: "Highland Rural Bank, Inc. (RB Kapangan, Inc.)",
      isAccepted: true
    },
    {
      bank: "Hiyas Banking Corporation (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "Iligan City Public School Teachers Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Ilocandia Community Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Ilocos Sur Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Iloilo City Development Bank",
      isAccepted: true
    },
    {
      bank: "Imus Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Innovative Rural Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Insular Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Inter-Asia Development Bank",
      isAccepted: true
    },
    {
      bank: "Isla Lipana & Co-Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Janiuay Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Jemba Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Judiciary Savings & Loan Association, Inc. (JUSLAI)",
      isAccepted: true
    },
    {
      bank: "Kaluyagan Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Kap. Kawani ng Quezon City Hall",
      isAccepted: true
    },
    {
      bank: "Katipunan Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Key Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Koronadal Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "La Consolacion Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lagawe Highlands Rural Bank",
      isAccepted: true
    },
    {
      bank: "Laguna Prestige Banking Corporation, (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Lapu-Lapu Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "LBC Development Bank",
      isAccepted: true
    },
    {
      bank: "Legazpi Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lemery Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lepanto Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Liberty Savings Bank Inc.",
      isAccepted: true
    },
    {
      bank: "Life Bank - Rural Bank of Maasin (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Life Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Limcoma Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Lipa Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "LUDB Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Luzon Development Bank",
      isAccepted: true
    },
    {
      bank: "Mactan Air Base Savings & Loan Association, Inc. (MABSLAI)",
      isAccepted: true
    },
    {
      bank: "Mactan Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Maharlika Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Malaca\xF1ang Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Malarayat Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Malasiqui Progressive Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Malaybalay Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Mallig Plains Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Manila Teacher's Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Mantrasco Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Maritime Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Mariwasa Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Masagana Rural Bank (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "Masantol Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Masuwerte Rural Bank of Bacoor, Inc.",
      isAccepted: true
    },
    {
      bank: "Mead Johnson Nutrition Employees Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Mega Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Meralco Savings & Loan Association (MESALA)",
      isAccepted: true
    },
    {
      bank: "Merchants Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Metro South Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Metrobank Card Corporation (A Finance Co.)",
      isAccepted: true
    },
    {
      bank: "Metro-Cebu Public Savings Bank",
      isAccepted: true
    },
    {
      bank: "Microfinance Maximum Savings Bank (Maxbank)",
      isAccepted: true
    },
    {
      bank: "Millenium Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Misamis Occidental Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Money Mall Rural Bank, Inc. (Com. RB Cuambog, Inc.)",
      isAccepted: true
    },
    {
      bank: "Mt. Carmel Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Multinational Investment Bancorporation",
      isAccepted: true
    },
    {
      bank: "Multi-Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Municipal Rural Bank of Libmanan, Inc.",
      isAccepted: true
    },
    {
      bank: "Municipal Rural Bank of Nabua, Inc.",
      isAccepted: true
    },
    {
      bank: "Muntinlupa Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "MVSM Bank (A Rural Bank Since 1953) INC.",
      isAccepted: true
    },
    {
      bank: "N2/NISF Military Personnel & Civilian Employees Savings & Loan Association, Inc. (N2/NISF MPCESLAI)",
      isAccepted: true
    },
    {
      bank: "National Teachers & Employees Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "NBI Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Negros Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "New Covenant Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Agoncillo, Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Binalbagan, Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of San Leonardo (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Tagkawayan, Inc.",
      isAccepted: true
    },
    {
      bank: "New Rural Bank of Victorias, Inc.",
      isAccepted: true
    },
    {
      bank: "NIA Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "North Pacific Banking Corp. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Northpoint Development Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "NPC Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Occidental Mindoro Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Occidental Mindoro Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "One Network Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Opportunity Kauswagan Bank, Inc. (A Microfinance TB)",
      isAccepted: true
    },
    {
      bank: "Optimum Development Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Oriental Tamaraw Rural Bank of Naujan, Inc.",
      isAccepted: true
    },
    {
      bank: "Orix Metro Leasing and Finance Corporation",
      isAccepted: true
    },
    {
      bank: "Ormon Bank (RB of Mulanay, Inc.)",
      isAccepted: true
    },
    {
      bank: "Own Bank, The Rural Bank of Cavite City, Inc.",
      isAccepted: true
    },
    {
      bank: "Pacific Ace Savings Bank",
      isAccepted: true
    },
    {
      bank: "PAL Employees Savings & Loan Association (PESALA)",
      isAccepted: true
    },
    {
      bank: "Pampanga Development Bank",
      isAccepted: true
    },
    {
      bank: "Pangasinan Bank (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Panguil Bay Rural Bank",
      isAccepted: true
    },
    {
      bank: "Partner Rural Bank (Cotabato), Inc.",
      isAccepted: true
    },
    {
      bank: "Pe\xF1afrancia Rural Bank of Calabanga, Inc.",
      isAccepted: true
    },
    {
      bank: "Penbank, Inc. (A Private Development Bank) (Formerly: Peninsula Rural Bank, Inc.)",
      isAccepted: true
    },
    {
      bank: "People's Bank of Caraga, Inc.",
      isAccepted: true
    },
    {
      bank: "People's Rural Bank (Gen. Santos City), Inc.",
      isAccepted: true
    },
    {
      bank: "Philippine Coast Guard Savings & Loan Association, Inc. (PCGSLAI)",
      isAccepted: true
    },
    {
      bank: "Philippine Depository and Trust Corp",
      isAccepted: true
    },
    {
      bank: "Philippine Navy Savings & Loan Association, Inc. (PNSLAI)",
      isAccepted: true
    },
    {
      bank: "Philippine Postal Savings Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Rural Banking Corp. (PR Bank)",
      isAccepted: true
    },
    {
      bank: "Philippine Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Philippine SME Bank, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "Philippine Trust Company",
      isAccepted: true
    },
    {
      bank: "Philnabank Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Philtrust Company Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Phimco Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "PlanBank-Rural Bank of Canlubang Planters, Inc.",
      isAccepted: true
    },
    {
      bank: "Port Community Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Premiere Development Bank",
      isAccepted: true
    },
    {
      bank: "Pres. Jose P. Laurel Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Pride Star Development Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Producers Savings Bank Corporation",
      isAccepted: true
    },
    {
      bank: "Professional Regulation Commission Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Progress Savings and Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Progressive Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Progressive Bank, Inc. (Progressive-A Rural Bank Inc.)",
      isAccepted: true
    },
    {
      bank: "Providence Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Provident Rural Bank of Sta. Cruz, Inc.",
      isAccepted: true
    },
    {
      bank: "Public Safety Savings & Loan Association, Inc. (PSSLAI)",
      isAccepted: true
    },
    {
      bank: "Quezon Capital Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Quezon Coconut Producers Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Quezon Traders Rural Bank of Candelaria, Inc.",
      isAccepted: true
    },
    {
      bank: "Racso's Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Rang-ay Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "RB of Do\xF1a Remedios Trinidad, Inc.",
      isAccepted: true
    },
    {
      bank: "RB of Pres. Manuel A. Roxas, Inc.",
      isAccepted: true
    },
    {
      bank: "RBG Imperial Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "RBT Bank, Inc., A Rural Bank",
      isAccepted: true
    },
    {
      bank: "RGC Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Rizal Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "RNG Coastal Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Rodriguez Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "RPP Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Abucay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Agoo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alabat, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alabel, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alaminos (Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alaminos (Pangasinan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alicia, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alimodian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Alitagtag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Altavas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Amadeo (Cavite), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Amlan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Anda, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angadanan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angat, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angeles, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Angono, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Antipolo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Apalit, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Aritao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Atimonan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bacnotan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Baco, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bacolod City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bacong (Negros Oriental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Badiangan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bagabag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bagac, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Baguio, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Balete, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Balingasag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Balungao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bambang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Banayoyo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Banga, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bangar, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bansud, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Barili, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Barotac Nuevo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Barotac Viejo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Basay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Basey, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Batac, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bato, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bauang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bayambang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bayawan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bayombong, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Benito Soliven, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bogo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bolinao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bonifacio, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bontoc, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Borongan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Brookes Point, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bucay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Buenavista, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bugasong, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Buguias, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Burauen, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Bustos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Caba (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabadbaran, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabangan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabatuan (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cabugao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cadiz, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cainta, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calaca, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calamba, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calasiao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calauan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calbayog City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calinog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Caloocan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Calubian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Camalig, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Candelaria (Quezon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Candelaria (Zambales), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Capalonga, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cardona, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Casiguran, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Catubig, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cauayan (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cavinti, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cebu South, Inc. (Sibonga RB)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Central Pangasinan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Claveria, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Compostela (Comval), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cotabato, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cuartero, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cuenca, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Cuyo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dasmari\xF1as, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Datu Paglas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Digos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dolores (Quezon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Donsol, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dulag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dumangas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Dupax , Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of El Salvador, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Escalante, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gainza, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Galimuyod, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gandara, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gattaran, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of General Luna, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of General Trias, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gigaquit, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gingoog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gitagum, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Gloria, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Goa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Guihulngan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Guinobatan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Guiuan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hagonoy, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hermosa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hilongos,Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hindang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Hinundayan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ibajay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Iligan City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ilog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Iloilo City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Infanta, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Initao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Irosin, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Itogon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jaen, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jamindan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Javier, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jimenez, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jordan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Jose Panganiban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kabasalan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kapalong, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Karomatan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kawit, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kiamba, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kibawe, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kinogitan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Kolambugan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of La Paz (Tarlac), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of La Trinidad, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Labason, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Labrador, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lanuza, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Larena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lebak, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Leganes, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lemery (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Liloy, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Limay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lipa City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lobo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Loboc, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Loon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lopez Jaena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Loreto, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lubao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lucban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luisiana, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lumban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luna (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luna (Kalinga-Apayao), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Luna (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Lupao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ma-ao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maasin (So. Leyte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mabalacat, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mabini (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mabitac, Inc. (Fortune Bank)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maddela, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Madridejos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Magdalena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Magsingal, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mahaplag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maigo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Majayjay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Makato, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Malinao (Aklan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Malitbog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Malolos, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mambusao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Manapla, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mandaue, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mangaldan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Manolo Fortich, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Manukan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maragondon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Marayo (Negros Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Maria Aurora, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Marilag (Sta. Maria,Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Matag-ob, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mati, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mauban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mawab, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Medina, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mendez, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Mexico, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Miagao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Midsayap, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of M'lang, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Montalban, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Montevista, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Nabunturan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Nagcarlan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Naguilian (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Naic, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Nasugbu, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Naval, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of New Corella, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of New Washington, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Norala, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ocampo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Odiongan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ormoc City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Oroquieta, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Oslob, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Oton, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Padre Burgos (Southern Leyte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Padre Garcia, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Paete, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pagadian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pagbilao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pagsanjan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pamplona (Camarines Sur), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pamplona (Negros Oriental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pana-on, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Panay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pandi, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pangil, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Paracale, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pavia, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pilar (Bataan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pilar (Sorsogon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pinamalayan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Placer (Surigao del Norte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Plaridel (Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Plaridel (Misamis Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pola, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Polomolok, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Porac, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pototan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pozorrubio, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pres. Quirino, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Puerto Galera, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Pura, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Quezon (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ragay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Ramon, Inc,",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Reina Mercedes, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rizal (Kalinga), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rizal (Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rizal (Z.N.), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Rosario (La Union), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Roxas (Oriental Mindoro), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sagada, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sagay (Negros Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Salcedo, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Salinas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Salug, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sampaloc, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Agustin, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Antonio (Quezon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Enrique, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Fabian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Fernando (Camarines Sur), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Fernando (Cebu), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Jacinto, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Jose (Camarines), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Juan (Southern Leyte), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Lorenzo Ruiz (Siniloan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Luis (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Luis (Pampanga), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Manuel (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Marcelino, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Mateo (Isabela), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Miguel (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Narciso (Zambales), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Nicolas (Pangasinan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Pascual, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Quintin, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Rafael (Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of San Vicente, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sanchez Mira, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Santa Catalina, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Santiago de Libon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sapian, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sasmuan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Seven Lakes, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Siaton, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sibalom, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sibulan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Silay City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Siocon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sipocot, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Socorro, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Solano, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Barbara (Iloilo), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Elena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Fe (Romblon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Ignacia, Inc. (Signa Bank)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Magdalena, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Maria (Ilocos Sur) Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Rosa (Laguna), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sta. Rosa de Lima, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sto. Domingo (Nueva Ecija), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sto. Tomas (Davao), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Sudipen, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Taal, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tabuk, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Taft, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tagaytay City, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talisay (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talisay (Cebu), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talisay (Negros Occidental), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Talugtog, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tandag, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tangub, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tanjay, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tayabas, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Taysan, Inc. (Banco Batangas)",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Teresa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tibiao, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tigaon, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tigbauan, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tudela, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Tumauini, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Valencia (Bukidnon), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Valencia (Negros Or.), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Victoria (Oriental Mindoro), Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Victoria, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Villaverde, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Villaviciosa, Inc.",
      isAccepted: true
    },
    {
      bank: "Rural Bank of Zarraga, Inc.",
      isAccepted: true
    },
    {
      bank: "Sadiri Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Salug Valley Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sampaguita Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "San Bartolome Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "San Fernando Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "San Francisco Del Monte Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sarangani Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings & Loan Association of Government Auditors, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings & Loan Association of Mataas na Kahoy, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings & Loan Association of Power Employees, Inc.",
      isAccepted: true
    },
    {
      bank: "Savings &n Loan Association of P & G Phil. Employees, Inc.",
      isAccepted: true
    },
    {
      bank: "Saviour Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Science Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Second Rural Bank of Meycauayan, Inc.",
      isAccepted: true
    },
    {
      bank: "Second Rural Bank of San Luis (Pampanga), Inc.",
      isAccepted: true
    },
    {
      bank: "Second Rural Bank of Valenzuela, Inc.",
      isAccepted: true
    },
    {
      bank: "Secured Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Shell Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Shell Refinery Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Shoe Mart Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Siam Bank (CRB of Lugait Inc.)",
      isAccepted: true
    },
    {
      bank: "Siargao Bank, Inc. (A Rural Bank) RB of Dapa, Inc.",
      isAccepted: true
    },
    {
      bank: "Silahis Bank Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Silangan Savings and Loan Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Smart Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Sorsogon Provincial Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "South Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Southeast Country Bank, Inc. - RB of Camaligan, Inc.",
      isAccepted: true
    },
    {
      bank: "Southern Leyte Cooperative Bank",
      isAccepted: true
    },
    {
      bank: "Southern Luzon Teachers Savings & Loan Association, Inc. (SLTSLAI)",
      isAccepted: true
    },
    {
      bank: "Southernside Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "St. Michael Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sta. Maria Rural Bank (Bulacan), Inc.",
      isAccepted: true
    },
    {
      bank: "State Investment Trust, Inc.",
      isAccepted: true
    },
    {
      bank: "Sterling Bank of Asia, Inc. (A Savings Bank)",
      isAccepted: true
    },
    {
      bank: "Sto. Ni\xF1o Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Sto. Rosario Rural Bank (Batangas), Inc.",
      isAccepted: true
    },
    {
      bank: "Sugbuanon Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Summit Bank (Rural Bank of Tublay, Inc.)",
      isAccepted: true
    },
    {
      bank: "Summit Rural Bank of Lipa City, Inc.",
      isAccepted: true
    },
    {
      bank: "Sunrise Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Supreme Court Savings & Loan Association, Inc. (SCSLAI)",
      isAccepted: true
    },
    {
      bank: "Surigao City Evergreen Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Surigao Officials & Employees Savings & Loan Association",
      isAccepted: true
    },
    {
      bank: "Surigaonon Rural Banking Corporation",
      isAccepted: true
    },
    {
      bank: "Synergy Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tamaraw Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tanay Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Telecommunications Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "The Country Bank, Inc. (RB Bongabong, Inc.)",
      isAccepted: true
    },
    {
      bank: "The Palawan Bank (Palawan Development Bank, Inc.)",
      isAccepted: true
    },
    {
      bank: "Tiaong Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tong Yang Savings Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Tower Development Bank",
      isAccepted: true
    },
    {
      bank: "Towncall Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Toyota Financial Services Philippines Corporation (TFSPH)",
      isAccepted: true
    },
    {
      bank: "Toyota Motor Philippines Savings & Loan Association, Inc. (TMPSLAI)",
      isAccepted: true
    },
    {
      bank: "Turumba Rural Bank of Pakil, Inc.",
      isAccepted: true
    },
    {
      bank: "Unilink Bank Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "United Consumers Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "United Overseas Bank Philippines",
      isAccepted: true
    },
    {
      bank: "United People's Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Unity Bank (A Rural Bank), Inc.",
      isAccepted: true
    },
    {
      bank: "Universal Rural Bank of Lopez, Inc.",
      isAccepted: true
    },
    {
      bank: "University of Luzon Savings & Loan Association",
      isAccepted: true
    },
    {
      bank: "University Savings Bank",
      isAccepted: true
    },
    {
      bank: "Unlad Rural Bank of Noveleta, Inc.",
      isAccepted: true
    },
    {
      bank: "Upland Rural Bank of Dalaguete (Cebu), Inc.",
      isAccepted: true
    },
    {
      bank: "Utility Bank, Inc. (A Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Valiant Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Vigan Banco Rural, Incorporada",
      isAccepted: true
    },
    {
      bank: "Village Bank, Inc. (A Thrift Bank)",
      isAccepted: true
    },
    {
      bank: "Vision Bank, Inc.- A Rural Bank (Microfinance)",
      isAccepted: true
    },
    {
      bank: "Vizcaya Bank, A Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Water and Sewerage Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Wealth Bank - A Development Bank",
      isAccepted: true
    },
    {
      bank: "Women's Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Wyeth Suaco Employees Savings & Loan Association, Inc.",
      isAccepted: true
    },
    {
      bank: "Xavier-Punla Rural Bank, Inc.",
      isAccepted: true
    },
    {
      bank: "Xavier-Tibod Bank, Inc. (Microfinance Rural Bank)",
      isAccepted: true
    },
    {
      bank: "Zambales Rural Bank (Zambank)-RB Castillejos",
      isAccepted: true
    }
  ],
  Bangladesh: [
    {
      bank: "AB Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bank Alfalah Limited",
      isAccepted: true
    },
    {
      bank: "The City Bank Limited",
      isAccepted: true
    },
    {
      bank: "Eastern Bank Limited",
      isAccepted: true
    },
    {
      bank: "International Finance Investment and Commerce Bank Limited",
      isAccepted: true
    },
    {
      bank: "National Credit and Commerce Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Southeast Bank Ltd",
      isAccepted: true
    },
    {
      bank: "One Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Mutual trust Bank Ltd",
      isAccepted: true
    },
    {
      bank: "BRAC Bank Ltd",
      isAccepted: true
    },
    {
      bank: "First Security Islami Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Shahjalal Islami Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "State Bank of India",
      isAccepted: false
    },
    {
      bank: "Citi Bank",
      isAccepted: true
    },
    {
      bank: "Commercial Bank of Ceylon Ltd",
      isAccepted: true
    },
    {
      bank: "The Hong Kong and Shanghai Banking Corporation Ltd",
      isAccepted: true
    },
    {
      bank: "Dhaka Bank Limited",
      isAccepted: true
    },
    {
      bank: "Premier Bank Limited",
      isAccepted: true
    },
    {
      bank: "Prime Bank Limited",
      isAccepted: true
    },
    {
      bank: "Pubali Bank Limited",
      isAccepted: true
    },
    {
      bank: "Standard Bank Limited",
      isAccepted: true
    },
    {
      bank: "Trust Bank Limited",
      isAccepted: true
    },
    {
      bank: "Woori Bank Limited",
      isAccepted: true
    },
    {
      bank: "Agrani Bank Limited",
      isAccepted: true
    },
    {
      bank: "Al-Arafah Islami Bank Limited",
      isAccepted: true
    },
    {
      bank: "Ansar-Vidipi Bank",
      isAccepted: true
    },
    {
      bank: "Bangladesh Commerce Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bangladesh Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bangladesh Krishi Bank",
      isAccepted: true
    },
    {
      bank: "Bangladesh Small Industries and Commerce (BASIC) Bank Limited",
      isAccepted: true
    },
    {
      bank: "Bank Asia Limited",
      isAccepted: true
    },
    {
      bank: "Co-operative Bank",
      isAccepted: true
    },
    {
      bank: "Dutch Bangla Bank Limited",
      isAccepted: true
    },
    {
      bank: "Export Import Bank of Bangladesh Limited",
      isAccepted: true
    },
    {
      bank: "Grameen Bank",
      isAccepted: true
    },
    {
      bank: "Habib Bank Limited",
      isAccepted: true
    },
    {
      bank: "Islami Bank Bangladesh Limited",
      isAccepted: true
    },
    {
      bank: "Jamuna Bank Limited Janata Bank Limited",
      isAccepted: true
    },
    {
      bank: "Karmashangstan Bank",
      isAccepted: true
    },
    {
      bank: "Mercantile Bank Limited",
      isAccepted: true
    },
    {
      bank: "National Bank Limited",
      isAccepted: true
    },
    {
      bank: "National Bank of Pakistan",
      isAccepted: true
    },
    {
      bank: "Rupali Bank Limited",
      isAccepted: true
    },
    {
      bank: "Social Islami Bank Limited",
      isAccepted: true
    },
    {
      bank: "Sonali Bank Limited",
      isAccepted: true
    },
    {
      bank: "ICB Islamic Bank Limited",
      isAccepted: true
    },
    {
      bank: "United Commercial Bank Limited",
      isAccepted: true
    },
    {
      bank: "Uttara Bank Limited",
      isAccepted: true
    }
  ],
  "Sri Lanka": [
    {
      bank: "Amana Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Axis Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Bank of Ceylon",
      isAccepted: true
    },
    {
      bank: "Citibank, N.A.",
      isAccepted: true
    },
    {
      bank: "Commercial Bank of Ceylon PLC",
      isAccepted: true
    },
    {
      bank: "Deutsche Bank AG",
      isAccepted: true
    },
    {
      bank: "DFCC Vardhana Bank PLC",
      isAccepted: true
    },
    {
      bank: "Habib Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Hatton National Bank PLC",
      isAccepted: true
    },
    {
      bank: "ICICI Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Indian Bank",
      isAccepted: true
    },
    {
      bank: "Indian Overseas Bank",
      isAccepted: true
    },
    {
      bank: "MCB Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Development Bank PLC",
      isAccepted: true
    },
    {
      bank: "Nations Trust Bank PLC",
      isAccepted: true
    },
    {
      bank: "Pan Asia Banking Corporation PLC",
      isAccepted: true
    },
    {
      bank: "People's Bank",
      isAccepted: true
    },
    {
      bank: "Public Bank Berhad",
      isAccepted: true
    },
    {
      bank: "Sampath Bank PLC",
      isAccepted: true
    },
    {
      bank: "Seylan Bank PLC",
      isAccepted: true
    },
    {
      bank: "Standard Chartered Bank",
      isAccepted: true
    },
    {
      bank: "State Bank of India",
      isAccepted: true
    },
    {
      bank: "The Hongkong & Shanghai Banking Corporation Ltd",
      isAccepted: true
    },
    {
      bank: "Union Bank of Colombo PLC",
      isAccepted: true
    },
    {
      bank: "DFCC Bank",
      isAccepted: true
    },
    {
      bank: "Housing Development Finance",
      isAccepted: true
    },
    {
      bank: "Lankaputra Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "MBSL Savings Bank Ltd",
      isAccepted: true
    },
    {
      bank: "National Savings Bank",
      isAccepted: true
    },
    {
      bank: "Pradeshiya Sanwardhana Bank",
      isAccepted: true
    },
    {
      bank: "Sanasa Development Bank Ltd",
      isAccepted: true
    },
    {
      bank: "Sri Lanka Sarvings Bank Ltd",
      isAccepted: true
    },
    {
      bank: "State Mortgage & Investment Bank",
      isAccepted: true
    }
  ]
});

// src/finance-currencies.ts
function deepFreeze4(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze4(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var currencies = deepFreeze4([
  {
    symbol: "$",
    name: "US Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "USD",
    name_plural: "US dollars"
  },
  {
    symbol: "CA$",
    name: "Canadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "CAD",
    name_plural: "Canadian dollars"
  },
  {
    symbol: "\u20AC",
    name: "Euro",
    symbol_native: "\u20AC",
    decimal_digits: 2,
    rounding: 0,
    code: "EUR",
    name_plural: "euros"
  },
  {
    symbol: "AED",
    name: "United Arab Emirates Dirham",
    symbol_native: "\u062F.\u0625.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "AED",
    name_plural: "UAE dirhams"
  },
  {
    symbol: "Af",
    name: "Afghan Afghani",
    symbol_native: "\u060B",
    decimal_digits: 0,
    rounding: 0,
    code: "AFN",
    name_plural: "Afghan Afghanis"
  },
  {
    symbol: "ALL",
    name: "Albanian Lek",
    symbol_native: "Lek",
    decimal_digits: 0,
    rounding: 0,
    code: "ALL",
    name_plural: "Albanian lek\xEB"
  },
  {
    symbol: "AMD",
    name: "Armenian Dram",
    symbol_native: "\u0564\u0580.",
    decimal_digits: 0,
    rounding: 0,
    code: "AMD",
    name_plural: "Armenian drams"
  },
  {
    symbol: "\u0192",
    name: "Netherlands Antillean guilder",
    symbol_native: "\u0192",
    decimal_digits: 0,
    rounding: 0,
    code: "ANG",
    name_plural: "Netherlands Antillean guilder"
  },
  {
    symbol: "Kz",
    name: "Angolan Kwanza",
    symbol_native: "Kz",
    decimal_digits: 0,
    rounding: 0,
    code: "AOA",
    name_plural: "Angolan Kwanzas"
  },
  {
    symbol: "AR$",
    name: "Argentine Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "ARS",
    name_plural: "Argentine pesos"
  },
  {
    symbol: "AU$",
    name: "Australian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "AUD",
    name_plural: "Australian dollars"
  },
  {
    symbol: "man.",
    name: "Azerbaijani Manat",
    symbol_native: "\u043C\u0430\u043D.",
    decimal_digits: 2,
    rounding: 0,
    code: "AZN",
    name_plural: "Azerbaijani manats"
  },
  {
    symbol: "KM",
    name: "Bosnia-Herzegovina Convertible Mark",
    symbol_native: "KM",
    decimal_digits: 2,
    rounding: 0,
    code: "BAM",
    name_plural: "Bosnia-Herzegovina convertible marks"
  },
  {
    symbol: "BBD$",
    name: "Barbadian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BBD",
    name_plural: "Barbadian Dollars"
  },
  {
    symbol: "Tk",
    name: "Bangladeshi Taka",
    symbol_native: "\u09F3",
    decimal_digits: 2,
    rounding: 0,
    code: "BDT",
    name_plural: "Bangladeshi takas"
  },
  {
    symbol: "BGN",
    name: "Bulgarian Lev",
    symbol_native: "\u043B\u0432.",
    decimal_digits: 2,
    rounding: 0,
    code: "BGN",
    name_plural: "Bulgarian leva"
  },
  {
    symbol: "BD",
    name: "Bahraini Dinar",
    symbol_native: "\u062F.\u0628.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "BHD",
    name_plural: "Bahraini dinars"
  },
  {
    symbol: "FBu",
    name: "Burundian Franc",
    symbol_native: "FBu",
    decimal_digits: 0,
    rounding: 0,
    code: "BIF",
    name_plural: "Burundian francs"
  },
  {
    symbol: "BN$",
    name: "Brunei Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BND",
    name_plural: "Brunei dollars"
  },
  {
    symbol: "$",
    name: "Bermudian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BMD",
    name_plural: "Bermudian Dollar"
  },
  {
    symbol: "Bs",
    name: "Bolivian Boliviano",
    symbol_native: "Bs",
    decimal_digits: 2,
    rounding: 0,
    code: "BOB",
    name_plural: "Bolivian bolivianos"
  },
  {
    symbol: "R$",
    name: "Brazilian Real",
    symbol_native: "R$",
    decimal_digits: 2,
    rounding: 0,
    code: "BRL",
    name_plural: "Brazilian reals"
  },
  {
    symbol: "Nu.",
    name: "Bhutanese Ngultrum",
    symbol_native: "Nu.",
    decimal_digits: 2,
    rounding: 0,
    code: "BTN",
    name_plural: "Bhutanese Ngultrum"
  },
  {
    symbol: "BWP",
    name: "Botswanan Pula",
    symbol_native: "P",
    decimal_digits: 2,
    rounding: 0,
    code: "BWP",
    name_plural: "Botswanan pulas"
  },
  {
    symbol: "BYR",
    name: "Belarusian Ruble",
    symbol_native: "BYR",
    decimal_digits: 0,
    rounding: 0,
    code: "BYR",
    name_plural: "Belarusian rubles"
  },
  {
    symbol: "BZ$",
    name: "Belize Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "BZD",
    name_plural: "Belize dollars"
  },
  {
    symbol: "CDF",
    name: "Congolese Franc",
    symbol_native: "FrCD",
    decimal_digits: 2,
    rounding: 0,
    code: "CDF",
    name_plural: "Congolese francs"
  },
  {
    symbol: "CHF",
    name: "Swiss Franc",
    symbol_native: "CHF",
    decimal_digits: 2,
    rounding: 0.05,
    code: "CHF",
    name_plural: "Swiss francs"
  },
  {
    symbol: "CL$",
    name: "Chilean Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "CLP",
    name_plural: "Chilean pesos"
  },
  {
    symbol: "CN\xA5",
    name: "Chinese Yuan",
    symbol_native: "CN\xA5",
    decimal_digits: 2,
    rounding: 0,
    code: "CNY",
    name_plural: "Chinese yuan"
  },
  {
    symbol: "CO$",
    name: "Colombian Peso",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "COP",
    name_plural: "Colombian pesos"
  },
  {
    symbol: "\u20A1",
    name: "Costa Rican Col\xF3n",
    symbol_native: "\u20A1",
    decimal_digits: 0,
    rounding: 0,
    code: "CRC",
    name_plural: "Costa Rican col\xF3ns"
  },
  {
    symbol: "CV$",
    name: "Cape Verdean Escudo",
    symbol_native: "CV$",
    decimal_digits: 2,
    rounding: 0,
    code: "CVE",
    name_plural: "Cape Verdean escudos"
  },
  {
    symbol: "K\u010D",
    name: "Czech Republic Koruna",
    symbol_native: "K\u010D",
    decimal_digits: 2,
    rounding: 0,
    code: "CZK",
    name_plural: "Czech Republic korunas"
  },
  {
    symbol: "Fdj",
    name: "Djiboutian Franc",
    symbol_native: "Fdj",
    decimal_digits: 0,
    rounding: 0,
    code: "DJF",
    name_plural: "Djiboutian francs"
  },
  {
    symbol: "Dkr",
    name: "Danish Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "DKK",
    name_plural: "Danish kroner"
  },
  {
    symbol: "RD$",
    name: "Dominican Peso",
    symbol_native: "RD$",
    decimal_digits: 2,
    rounding: 0,
    code: "DOP",
    name_plural: "Dominican pesos"
  },
  {
    symbol: "DA",
    name: "Algerian Dinar",
    symbol_native: "\u062F.\u062C.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "DZD",
    name_plural: "Algerian dinars"
  },
  {
    symbol: "Ekr",
    name: "Estonian Kroon",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "EEK",
    name_plural: "Estonian kroons"
  },
  {
    symbol: "EGP",
    name: "Egyptian Pound",
    symbol_native: "\u062C.\u0645.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "EGP",
    name_plural: "Egyptian pounds"
  },
  {
    symbol: "Nfk",
    name: "Eritrean Nakfa",
    symbol_native: "Nfk",
    decimal_digits: 2,
    rounding: 0,
    code: "ERN",
    name_plural: "Eritrean nakfas"
  },
  {
    symbol: "Br",
    name: "Ethiopian Birr",
    symbol_native: "Br",
    decimal_digits: 2,
    rounding: 0,
    code: "ETB",
    name_plural: "Ethiopian birrs"
  },
  {
    symbol: "\xA3",
    name: "Falkland Island Pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "FKP",
    name_plural: "Falkland Island Pounds"
  },
  {
    symbol: "\xA3",
    name: "British Pound Sterling",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "GBP",
    name_plural: "British pounds sterling"
  },
  {
    symbol: "GEL",
    name: "Georgian Lari",
    symbol_native: "GEL",
    decimal_digits: 2,
    rounding: 0,
    code: "GEL",
    name_plural: "Georgian laris"
  },
  {
    symbol: "GH\u20B5",
    name: "Ghanaian Cedi",
    symbol_native: "GH\u20B5",
    decimal_digits: 2,
    rounding: 0,
    code: "GHS",
    name_plural: "Ghanaian cedis"
  },
  {
    symbol: "\xA3",
    name: "Gibraltar Pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "GHS",
    name_plural: "Gibraltar pound"
  },
  {
    symbol: "FG",
    name: "Guinean Franc",
    symbol_native: "FG",
    decimal_digits: 0,
    rounding: 0,
    code: "GNF",
    name_plural: "Guinean francs"
  },
  {
    symbol: "GTQ",
    name: "Guatemalan Quetzal",
    symbol_native: "Q",
    decimal_digits: 2,
    rounding: 0,
    code: "GTQ",
    name_plural: "Guatemalan quetzals"
  },
  {
    symbol: "HK$",
    name: "Hong Kong Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "HKD",
    name_plural: "Hong Kong dollars"
  },
  {
    symbol: "HNL",
    name: "Honduran Lempira",
    symbol_native: "L",
    decimal_digits: 2,
    rounding: 0,
    code: "HNL",
    name_plural: "Honduran lempiras"
  },
  {
    symbol: "kn",
    name: "Croatian Kuna",
    symbol_native: "kn",
    decimal_digits: 2,
    rounding: 0,
    code: "HRK",
    name_plural: "Croatian kunas"
  },
  {
    symbol: "Ft",
    name: "Hungarian Forint",
    symbol_native: "Ft",
    decimal_digits: 0,
    rounding: 0,
    code: "HUF",
    name_plural: "Hungarian forints"
  },
  {
    symbol: "FJ$",
    name: "Fijian Dollar",
    symbol_native: "FJ$",
    decimal_digits: 2,
    rounding: 0,
    code: "FJD",
    name_plural: "Fijian dollars"
  },
  {
    symbol: "Rp",
    name: "Indonesian Rupiah",
    symbol_native: "Rp",
    decimal_digits: 0,
    rounding: 0,
    code: "IDR",
    name_plural: "Indonesian rupiahs"
  },
  {
    symbol: "\u20AA",
    name: "Israeli New Sheqel",
    symbol_native: "\u20AA",
    decimal_digits: 2,
    rounding: 0,
    code: "ILS",
    name_plural: "Israeli new sheqels"
  },
  {
    symbol: "Rs",
    name: "Indian Rupee",
    symbol_native: "\u099F\u0995\u09BE",
    decimal_digits: 2,
    rounding: 0,
    code: "INR",
    name_plural: "Indian rupees"
  },
  {
    symbol: "IQD",
    name: "Iraqi Dinar",
    symbol_native: "\u062F.\u0639.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "IQD",
    name_plural: "Iraqi dinars"
  },
  {
    symbol: "IRR",
    name: "Iranian Rial",
    symbol_native: "\uFDFC",
    decimal_digits: 0,
    rounding: 0,
    code: "IRR",
    name_plural: "Iranian rials"
  },
  {
    symbol: "Ikr",
    name: "Icelandic Kr\xF3na",
    symbol_native: "kr",
    decimal_digits: 0,
    rounding: 0,
    code: "ISK",
    name_plural: "Icelandic kr\xF3nur"
  },
  {
    symbol: "J$",
    name: "Jamaican Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "JMD",
    name_plural: "Jamaican dollars"
  },
  {
    symbol: "JD",
    name: "Jordanian Dinar",
    symbol_native: "\u062F.\u0623.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "JOD",
    name_plural: "Jordanian dinars"
  },
  {
    symbol: "\xA5",
    name: "Japanese Yen",
    symbol_native: "\uFFE5",
    decimal_digits: 0,
    rounding: 0,
    code: "JPY",
    name_plural: "Japanese yen"
  },
  {
    symbol: "\u0441",
    name: "Kyrgyzstani som",
    symbol_native: "\u0441",
    decimal_digits: 2,
    rounding: 0,
    code: "KES",
    name_plural: "Kyrgyzstani som"
  },
  {
    symbol: "Ksh",
    name: "Kyrgyzstani Som",
    symbol_native: "Ksh",
    decimal_digits: 2,
    rounding: 0,
    code: "KES",
    name_plural: "Kenyan shillings"
  },
  {
    symbol: "KHR",
    name: "Cambodian Riel",
    symbol_native: "\u17DB",
    decimal_digits: 2,
    rounding: 0,
    code: "KHR",
    name_plural: "Cambodian riels"
  },
  {
    symbol: "CF",
    name: "Comorian Franc",
    symbol_native: "FC",
    decimal_digits: 0,
    rounding: 0,
    code: "KMF",
    name_plural: "Comorian francs"
  },
  {
    symbol: "\u20A9",
    name: "South Korean Won",
    symbol_native: "\u20A9",
    decimal_digits: 0,
    rounding: 0,
    code: "KRW",
    name_plural: "South Korean won"
  },
  {
    symbol: "KD",
    name: "Kuwaiti Dinar",
    symbol_native: "\u062F.\u0643.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "KWD",
    name_plural: "Kuwaiti dinars"
  },
  {
    symbol: "$",
    name: "Cayman Islands dollar",
    symbol_native: "$\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "KYD",
    name_plural: "Cayman Islands dollarS"
  },
  {
    symbol: "KZT",
    name: "Kazakhstani Tenge",
    symbol_native: "\u0442\u04A3\u0433.",
    decimal_digits: 2,
    rounding: 0,
    code: "KZT",
    name_plural: "Kazakhstani tenges"
  },
  {
    symbol: "\u20AD",
    name: "Lao kip",
    symbol_native: "\u20AD\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "LAK",
    name_plural: "Lao kip"
  },
  {
    symbol: "LB\xA3",
    name: "Lebanese Pound",
    symbol_native: "\u0644.\u0644.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "LBP",
    name_plural: "Lebanese pounds"
  },
  {
    symbol: "SLRs",
    name: "Sri Lankan Rupee",
    symbol_native: "SL Re",
    decimal_digits: 2,
    rounding: 0,
    code: "LKR",
    name_plural: "Sri Lankan rupees"
  },
  {
    symbol: "$",
    name: "Liberian Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "LRD",
    name_plural: "Liberian Dollars"
  },
  {
    symbol: "Lt",
    name: "Lithuanian Litas",
    symbol_native: "Lt",
    decimal_digits: 2,
    rounding: 0,
    code: "LTL",
    name_plural: "Lithuanian litai"
  },
  {
    symbol: "Ls",
    name: "Latvian Lats",
    symbol_native: "Ls",
    decimal_digits: 2,
    rounding: 0,
    code: "LVL",
    name_plural: "Latvian lati"
  },
  {
    symbol: "LD",
    name: "Libyan Dinar",
    symbol_native: "\u062F.\u0644.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "LYD",
    name_plural: "Libyan dinars"
  },
  {
    symbol: "MAD",
    name: "Moroccan Dirham",
    symbol_native: "\u062F.\u0645.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "MAD",
    name_plural: "Moroccan dirhams"
  },
  {
    symbol: "MDL",
    name: "Moldovan Leu",
    symbol_native: "MDL",
    decimal_digits: 2,
    rounding: 0,
    code: "MDL",
    name_plural: "Moldovan lei"
  },
  {
    symbol: "MGA",
    name: "Malagasy Ariary",
    symbol_native: "MGA",
    decimal_digits: 0,
    rounding: 0,
    code: "MGA",
    name_plural: "Malagasy Ariaries"
  },
  {
    symbol: "MKD",
    name: "Macedonian Denar",
    symbol_native: "MKD",
    decimal_digits: 2,
    rounding: 0,
    code: "MKD",
    name_plural: "Macedonian denari"
  },
  {
    symbol: "MMK",
    name: "Myanma Kyat",
    symbol_native: "K",
    decimal_digits: 0,
    rounding: 0,
    code: "MMK",
    name_plural: "Myanma kyats"
  },
  {
    symbol: "MOP$",
    name: "Macanese Pataca",
    symbol_native: "MOP$",
    decimal_digits: 2,
    rounding: 0,
    code: "MOP",
    name_plural: "Macanese patacas"
  },
  {
    symbol: "MURs",
    name: "Mauritian Rupee",
    symbol_native: "MURs",
    decimal_digits: 0,
    rounding: 0,
    code: "MUR",
    name_plural: "Mauritian rupees"
  },
  {
    symbol: "MK",
    name: "Malawian Kwacha",
    symbol_native: "MK",
    decimal_digits: 2,
    rounding: 0,
    code: "MWK",
    name_plural: "Malawian Kwacha"
  },
  {
    symbol: "MX$",
    name: "Mexican Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "MXN",
    name_plural: "Mexican pesos"
  },
  {
    symbol: "RM",
    name: "Malaysian Ringgit",
    symbol_native: "RM",
    decimal_digits: 2,
    rounding: 0,
    code: "MYR",
    name_plural: "Malaysian ringgits"
  },
  {
    symbol: "MTn",
    name: "Mozambican Metical",
    symbol_native: "MTn",
    decimal_digits: 2,
    rounding: 0,
    code: "MZN",
    name_plural: "Mozambican meticals"
  },
  {
    symbol: "N$",
    name: "Namibian Dollar",
    symbol_native: "N$",
    decimal_digits: 2,
    rounding: 0,
    code: "NAD",
    name_plural: "Namibian dollars"
  },
  {
    symbol: "\u20A6",
    name: "Nigerian Naira",
    symbol_native: "\u20A6",
    decimal_digits: 2,
    rounding: 0,
    code: "NGN",
    name_plural: "Nigerian nairas"
  },
  {
    symbol: "C$",
    name: "Nicaraguan C\xF3rdoba",
    symbol_native: "C$",
    decimal_digits: 2,
    rounding: 0,
    code: "NIO",
    name_plural: "Nicaraguan c\xF3rdobas"
  },
  {
    symbol: "Nkr",
    name: "Norwegian Krone",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "NOK",
    name_plural: "Norwegian kroner"
  },
  {
    symbol: "NPRs",
    name: "Nepalese Rupee",
    symbol_native: "\u0928\u0947\u0930\u0942",
    decimal_digits: 2,
    rounding: 0,
    code: "NPR",
    name_plural: "Nepalese rupees"
  },
  {
    symbol: "NZ$",
    name: "New Zealand Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "NZD",
    name_plural: "New Zealand dollars"
  },
  {
    symbol: "OMR",
    name: "Omani Rial",
    symbol_native: "\u0631.\u0639.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "OMR",
    name_plural: "Omani rials"
  },
  {
    symbol: "B/.",
    name: "Panamanian Balboa",
    symbol_native: "B/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PAB",
    name_plural: "Panamanian balboas"
  },
  {
    symbol: "S/.",
    name: "Peruvian Sol",
    symbol_native: "S/.",
    decimal_digits: 2,
    rounding: 0,
    code: "PEN",
    name_plural: "Peruvian soles"
  },
  {
    symbol: "\u20B1",
    name: "Philippine Peso",
    symbol_native: "\u20B1",
    decimal_digits: 2,
    rounding: 0,
    code: "PHP",
    name_plural: "Philippine pesos"
  },
  {
    symbol: "PKRs",
    name: "Pakistani Rupee",
    symbol_native: "\u20A8",
    decimal_digits: 0,
    rounding: 0,
    code: "PKR",
    name_plural: "Pakistani rupees"
  },
  {
    symbol: "z\u0142",
    name: "Polish Zloty",
    symbol_native: "z\u0142",
    decimal_digits: 2,
    rounding: 0,
    code: "PLN",
    name_plural: "Polish zlotys"
  },
  {
    symbol: "\u20B2",
    name: "Paraguayan Guarani",
    symbol_native: "\u20B2",
    decimal_digits: 0,
    rounding: 0,
    code: "PYG",
    name_plural: "Paraguayan guaranis"
  },
  {
    symbol: "QR",
    name: "Qatari Rial",
    symbol_native: "\u0631.\u0642.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "QAR",
    name_plural: "Qatari rials"
  },
  {
    symbol: "RON",
    name: "Romanian Leu",
    symbol_native: "RON",
    decimal_digits: 2,
    rounding: 0,
    code: "RON",
    name_plural: "Romanian lei"
  },
  {
    symbol: "din.",
    name: "Serbian Dinar",
    symbol_native: "\u0434\u0438\u043D.",
    decimal_digits: 0,
    rounding: 0,
    code: "RSD",
    name_plural: "Serbian dinars"
  },
  {
    symbol: "RUB",
    name: "Russian Ruble",
    symbol_native: "\u0440\u0443\u0431.",
    decimal_digits: 2,
    rounding: 0,
    code: "RUB",
    name_plural: "Russian rubles"
  },
  {
    symbol: "RWF",
    name: "Rwandan Franc",
    symbol_native: "FR",
    decimal_digits: 0,
    rounding: 0,
    code: "RWF",
    name_plural: "Rwandan francs"
  },
  {
    symbol: "SR",
    name: "Saudi Riyal",
    symbol_native: "\u0631.\u0633.\u200F",
    decimal_digits: 2,
    rounding: 0,
    code: "SAR",
    name_plural: "Saudi riyals"
  },
  {
    symbol: "$",
    name: "Solomon Islander Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SBD",
    name_plural: "Solomon Islander Dollars"
  },
  {
    symbol: "SDG",
    name: "Sudanese Pound",
    symbol_native: "SDG",
    decimal_digits: 2,
    rounding: 0,
    code: "SDG",
    name_plural: "Sudanese pounds"
  },
  {
    symbol: "Skr",
    name: "Swedish Krona",
    symbol_native: "kr",
    decimal_digits: 2,
    rounding: 0,
    code: "SEK",
    name_plural: "Swedish kronor"
  },
  {
    symbol: "S$",
    name: "Singapore Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SGD",
    name_plural: "Singapore dollars"
  },
  {
    symbol: "Le",
    name: "Sierra Leonean Leone",
    symbol_native: "Le",
    decimal_digits: 2,
    rounding: 0,
    code: "SLL",
    name_plural: "Sierra Leonean Leone"
  },
  {
    symbol: "Ssh",
    name: "Somali Shilling",
    symbol_native: "Ssh",
    decimal_digits: 0,
    rounding: 0,
    code: "SOS",
    name_plural: "Somali shillings"
  },
  {
    symbol: "\xA3",
    name: "South Sudanese pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "SSP",
    name_plural: "South Sudanese pound"
  },
  {
    symbol: "Db",
    name: "Sao Tomean Dobra",
    symbol_native: "Db",
    decimal_digits: 0,
    rounding: 0,
    code: "STD",
    name_plural: "Sao Tomean Dobra"
  },
  {
    symbol: "Db",
    name: "Sao Tomean Dobra",
    symbol_native: "Db",
    decimal_digits: 0,
    rounding: 0,
    code: "STN",
    name_plural: "Sao Tomean Dobra"
  },
  {
    symbol: "SY\xA3",
    name: "Syrian Pound",
    symbol_native: "\u0644.\u0633.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "SYP",
    name_plural: "Syrian pounds"
  },
  {
    symbol: "L",
    name: "Swazi Lilangeni",
    symbol_native: "L\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "SZL",
    name_plural: "Swazi Lilangeni"
  },
  {
    symbol: "\u0E3F",
    name: "Thai Baht",
    symbol_native: "\u0E3F",
    decimal_digits: 2,
    rounding: 0,
    code: "THB",
    name_plural: "Thai baht"
  },
  {
    symbol: "\u0405\u041C",
    name: "Tajikistani Somoni",
    symbol_native: "\u0405\u041C",
    decimal_digits: 2,
    rounding: 0,
    code: "THB",
    name_plural: "Tajikistani Somoni"
  },
  {
    symbol: "DT",
    name: "Tunisian Dinar",
    symbol_native: "\u062F.\u062A.\u200F",
    decimal_digits: 3,
    rounding: 0,
    code: "TND",
    name_plural: "Tunisian dinars"
  },
  {
    symbol: "T$",
    name: "Tongan Pa\u02BBanga",
    symbol_native: "T$",
    decimal_digits: 2,
    rounding: 0,
    code: "TOP",
    name_plural: "Tongan pa\u02BBanga"
  },
  {
    symbol: "TL",
    name: "Turkish Lira",
    symbol_native: "TL",
    decimal_digits: 2,
    rounding: 0,
    code: "TRY",
    name_plural: "Turkish Lira"
  },
  {
    symbol: "TT$",
    name: "Trinidad and Tobago Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "TTD",
    name_plural: "Trinidad and Tobago dollars"
  },
  {
    symbol: "NT$",
    name: "New Taiwan Dollar",
    symbol_native: "NT$",
    decimal_digits: 2,
    rounding: 0,
    code: "TWD",
    name_plural: "New Taiwan dollars"
  },
  {
    symbol: "TSh",
    name: "Tanzanian Shilling",
    symbol_native: "TSh",
    decimal_digits: 0,
    rounding: 0,
    code: "TZS",
    name_plural: "Tanzanian shillings"
  },
  {
    symbol: "\u20B4",
    name: "Ukrainian Hryvnia",
    symbol_native: "\u20B4",
    decimal_digits: 2,
    rounding: 0,
    code: "UAH",
    name_plural: "Ukrainian hryvnias"
  },
  {
    symbol: "USh",
    name: "Ugandan Shilling",
    symbol_native: "USh",
    decimal_digits: 0,
    rounding: 0,
    code: "UGX",
    name_plural: "Ugandan shillings"
  },
  {
    symbol: "$U",
    name: "Uruguayan Peso",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "UYU",
    name_plural: "Uruguayan pesos"
  },
  {
    symbol: "UZS",
    name: "Uzbekistan Som",
    symbol_native: "UZS",
    decimal_digits: 0,
    rounding: 0,
    code: "UZS",
    name_plural: "Uzbekistan som"
  },
  {
    symbol: "Bs.F.",
    name: "Venezuelan Bol\xEDvar",
    symbol_native: "Bs.F.",
    decimal_digits: 2,
    rounding: 0,
    code: "VEF",
    name_plural: "Venezuelan bol\xEDvars"
  },
  {
    symbol: "\u20AB",
    name: "Vietnamese Dong",
    symbol_native: "\u20AB",
    decimal_digits: 0,
    rounding: 0,
    code: "VND",
    name_plural: "Vietnamese dong"
  },
  {
    symbol: "Vt",
    name: "Ni-Vanuatu Vatu",
    symbol_native: "Vt",
    decimal_digits: 0,
    rounding: 0,
    code: "VUV",
    name_plural: "Ni-Vanuatu Vatu"
  },
  {
    symbol: "FCFA",
    name: "CFA Franc BEAC",
    symbol_native: "FCFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XAF",
    name_plural: "CFA francs BEAC"
  },
  {
    symbol: "$",
    name: "East Caribbean Dollar",
    symbol_native: "$",
    decimal_digits: 0,
    rounding: 0,
    code: "XCD",
    name_plural: "East Caribbean Dollars"
  },
  {
    symbol: "CFA",
    name: "CFA Franc BCEAO",
    symbol_native: "CFA",
    decimal_digits: 0,
    rounding: 0,
    code: "XOF",
    name_plural: "CFA francs BCEAO"
  },
  {
    symbol: "Fr",
    name: "CFP franc",
    symbol_native: "Fr",
    decimal_digits: 0,
    rounding: 0,
    code: "XPF",
    name_plural: "CFP franc"
  },
  {
    symbol: "YR",
    name: "Yemeni Rial",
    symbol_native: "\u0631.\u064A.\u200F",
    decimal_digits: 0,
    rounding: 0,
    code: "YER",
    name_plural: "Yemeni rials"
  },
  {
    symbol: "R",
    name: "South African Rand",
    symbol_native: "R",
    decimal_digits: 2,
    rounding: 0,
    code: "ZAR",
    name_plural: "South African rand"
  },
  {
    symbol: "ZK",
    name: "Zambian Kwacha",
    symbol_native: "ZK",
    decimal_digits: 0,
    rounding: 0,
    code: "ZMK",
    name_plural: "Zambian kwachas"
  },
  {
    symbol: "Rf",
    name: "Maldivian rufiyaa",
    symbol_native: "\u0783",
    decimal_digits: 2,
    rounding: 0,
    code: "MVR",
    name_plural: "Maldivian rufiyaas"
  },
  {
    symbol: "\u0192",
    name: "Aruban Florin",
    symbol_native: "Afl",
    decimal_digits: 2,
    rounding: 0,
    code: "AWG",
    name_plural: "Aruban florin"
  },
  {
    symbol: "$",
    name: "Bahamian Dollar",
    symbol_native: "$, B$",
    decimal_digits: 2,
    rounding: 0,
    code: "BSD",
    name_plural: "Bahamian dollars"
  },
  {
    symbol: "L, M (pl.)",
    name: "Lesotho Loti",
    symbol_native: "L, M (pl.)",
    decimal_digits: 2,
    rounding: 0,
    code: "LSL",
    name_plural: "Lesotho maloti"
  },
  {
    symbol: "\u20B1",
    name: "Cuban Peso",
    symbol_native: "$, $MN, \u20B1",
    decimal_digits: 2,
    rounding: 0,
    code: "CUP",
    name_plural: "Cuban pesos"
  },
  {
    symbol: "\u0192",
    name: "Netherlands Antillean Guilder",
    symbol_native: "NA\u0192, NAf, \u0192, f",
    decimal_digits: 2,
    rounding: 0,
    code: "ANG",
    name_plural: "Netherlands antillean guilders"
  },
  {
    symbol: "D",
    name: "Gambian Dalasi",
    symbol_native: "D",
    decimal_digits: 2,
    rounding: 0,
    code: "GMD",
    name_plural: "Gambian dalasis"
  },
  {
    symbol: "$",
    name: "Guyanaese Dollar",
    symbol_native: "$, G$, GY$",
    decimal_digits: 2,
    rounding: 0,
    code: "GYD",
    name_plural: "Guyanaese dollars"
  },
  {
    symbol: "G",
    name: "Haitian Gourde",
    symbol_native: "G",
    decimal_digits: 2,
    rounding: 0,
    code: "HTG",
    name_plural: "Haitian gourdes"
  },
  {
    symbol: "UM",
    name: "Mauritanian Ouguiya",
    symbol_native: "UM",
    decimal_digits: 2,
    rounding: 0,
    code: "MRU",
    name_plural: "Mauritanian ouguiya"
  },
  {
    symbol: "\u20AE",
    name: "Mongolian Tughrik",
    symbol_native: "\u20AE",
    decimal_digits: 2,
    rounding: 0,
    code: "MNT",
    name_plural: "Mongolian tughrik"
  },
  {
    symbol: "\u20A9",
    name: "North Korean Won",
    symbol_native: "\u20A9",
    decimal_digits: 2,
    rounding: 0,
    code: "KPW",
    name_plural: "North Korean won"
  },
  {
    symbol: "K",
    name: "Papua New Guinean Kina",
    symbol_native: "K",
    decimal_digits: 2,
    rounding: 0,
    code: "PGK",
    name_plural: "Papua New Guinean kina"
  },
  {
    symbol: "\xA3",
    name: "Saint Helenian Pound",
    symbol_native: "\xA3",
    decimal_digits: 2,
    rounding: 0,
    code: "SHP",
    name_plural: "Saint Helenian pounds"
  },
  {
    symbol: "SAT$",
    name: "Samoan Tala",
    symbol_native: "$, SAT$, SAT, ST, T",
    decimal_digits: 2,
    rounding: 0,
    code: "WST",
    name_plural: "Samoan talas"
  },
  {
    symbol: "SRs",
    name: "Seychellois Rupee",
    symbol_native: "SRe, SR, Re, Rs",
    decimal_digits: 2,
    rounding: 0,
    code: "SCR",
    name_plural: "Seychellois rupees"
  },
  {
    symbol: "$",
    name: "Surinamese Dollar",
    symbol_native: "$",
    decimal_digits: 2,
    rounding: 0,
    code: "SRD",
    name_plural: "Surinamese dollars"
  },
  {
    symbol: "M",
    name: "Turkmenistani Manat",
    symbol_native: "M",
    decimal_digits: 2,
    rounding: 0,
    code: "TMT",
    name_plural: "Turkmenistani manats"
  }
]);

// src/finance.ts
function deepFreeze5(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze5(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var defaultFinance = deepFreeze5({
  courseFeeDepositReqd: "",
  courseFeeDeposit: void 0,
  courseFeeDepositDate: "",
  courseFeeDepositNotReqdReason: "",
  accomDepositReqd: "",
  accomDeposit: 0,
  accomDepositDate: "",
  organisationSponsorship: {},
  scholarshipSponsorship: {},
  educationSponsorship: {},
  familySponsorship: {},
  otherSponsorship: {},
  fundingSummary: {
    courseFees: [],
    studentLivingCost: {
      label: "",
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    spouseLivingCost: {
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    childrenLivingCost: {
      number: 0,
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    totalToBeShown: 0,
    totalRemaining: 0,
    totalInvalid: 0
  },
  isSectionStarted: false,
  isSectionComplete: false
});
var fundingSources = deepFreeze5([
  {
    id: "organisationSponsorship",
    label: "Company or Government Sponsorship",
    button: "Add Sponsorship",
    buttonAlt: "Add another Sponsorship",
    saveButtonText: "Save Sponsorship Details"
  },
  {
    id: "scholarshipSponsorship",
    label: "University Scholarship or Discount",
    button: "Add Scholarship",
    buttonAlt: "Add another scholarship",
    saveButtonText: "Save Scholarship Details"
  },
  {
    id: "educationSponsorship",
    label: "Education Loan",
    button: "Add Loan",
    buttonAlt: "Add another loan",
    saveButtonText: "Save Loan Details"
  },
  {
    id: "familySponsorship",
    label: "Myself or My Family",
    button: "Add Bank Account",
    buttonAlt: "Add another bank account",
    saveButtonText: "Save Funding Details"
  },
  {
    id: "otherSponsorship",
    label: "Other",
    button: "Add Other",
    buttonAlt: "Add another Other",
    saveButtonText: "Save Other Details"
  }
]);
var INNER_LONDON_LIVING_COST = 1529;
var OUTER_LONDON_LIVING_COST = 1171;
var MAX_ACCOMMODATION_DEPOSIT = 1529;

// src/import-data.ts
function deepFreeze6(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze6(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var defaultImportData = deepFreeze6({
  studentNo: "",
  email: "",
  familyName: "",
  givenName: "",
  offers: []
});
export {
  INNER_LONDON_LIVING_COST,
  MAX_ACCOMMODATION_DEPOSIT,
  OUTER_LONDON_LIVING_COST,
  currencies,
  defaultCore,
  defaultFinance,
  defaultImportData,
  defaultOffer,
  fundingSources,
  restrictedCountryBanks
};
